/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Backpac API
 * The Backpac API description
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AddYoutubeChannelRequestDto,
  AddYoutubeChannelResponseDto,
  CheckYoutubeChannelRequestDto,
  CheckYoutubeChannelResponseDto,
  CreateInvitationRequestDto,
  FavoriteMusicRequestDto,
  GetAlbumAnalyticsApiV1Params,
  GetAlbumAnalyticsResponseDto,
  GetAlbumDetailAnalyticsResponseDto,
  GetAlbumDetailCountryApiV1Params,
  GetAlbumDetailCountryResponseDto,
  GetAlbumDetailOverviewApiV1Params,
  GetAlbumDetailPlatformApiV1Params,
  GetAlbumDetailPlatformResponseDto,
  GetAlbumDetailResponseDto,
  GetArtistAnalyticsApiV1Params,
  GetArtistAnalyticsResponseDto,
  GetAvailableAnalyticsResponseDto,
  GetAvailableDataUntilResponseDto,
  GetCampaignEngagementResponseDTO,
  GetCampaignResponseDTO,
  GetCampaignVideoPreviewApiV1Params,
  GetCampaignsResponseDTO,
  GetChannelAnalyticsApiV1Params,
  GetChannelAnalyticsResponseDto,
  GetChannelSettlementHistoryApiV1Params,
  GetChannelVideosAnalyticsApiV1Params,
  GetChannelVideosSummaryAnalyticsResponseDto,
  GetChannelsResponseDto,
  GetCountryAnalyticsApiV1Params,
  GetCountryAnalyticsResponseDto,
  GetEstimatedMetricsResponseDto,
  GetMoodResponseDto,
  GetMusicsApiV1Params,
  GetOverviewAnalyticsApiV1Params,
  GetOverviewAnalyticsResponseDto,
  GetPayoutHistoryByChannelResponseDto,
  GetPayoutHistoryResponseDto,
  GetPayoutMethodsResponseDto,
  GetPayoutStatusResponseDto,
  GetPlatformAnalyticsApiV1Params,
  GetPlatformAnalyticsResponseDto,
  GetSettlementHistoryResponseDto,
  GetTaxInfoResponseDto,
  GetTrackAnalyticsApiV1Params,
  GetTrackAnalyticsResponseDto,
  GetTrackDetailAnalyticsResponseDto,
  GetTrackDetailCountryApiV1Params,
  GetTrackDetailCountryResponseDto,
  GetTrackDetailOverviewApiV1Params,
  GetTrackDetailPlatformApiV1Params,
  GetTrackDetailPlatformResponseDto,
  GetTrackDetailResponseDto,
  GetTrolleyLinkResponseDto,
  GetVideoPreviewResponseDTO,
  GetWorkspaceInvitaitonResponseDto,
  GetWorkspaceInvitaitonsResponseDto,
  GetWorkspaceMeResponseDto,
  GetWorkspaceMemberResponseDto,
  GetWorkspaceMembersResponseDto,
  GetWorkspaceResponseDto,
  GetWorkspacesResponseDto,
  JoinCampaignRequestDTO,
  JoinCampaignYoutubeRequestDTO,
  PaginatedMusicsResponseDto,
  RefreshEstimatedMetricsResponseDto,
  RegisterInstagramChannelRequestDto,
  SubmitVideoRequestDTO,
  SubmitYoutubeVideoRequestDTO,
  UpdateTaxInformationRequestDto,
  UpdateWorkspaceMemberRequestDto,
  UpdateWorkspaceRequestDto,
  UploadFileApiV1Params,
  VerifyYoutubeChannelRequestDto
} from './models';

import { apiClient } from '../client';
type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type uploadFileApiV1Response200 = {
  data: void
  status: 200
}
    
export type uploadFileApiV1ResponseComposite = uploadFileApiV1Response200;
    
export type uploadFileApiV1Response = uploadFileApiV1ResponseComposite & {
  headers: Headers;
}

export const getUploadFileApiV1Url = (params: UploadFileApiV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `http://localhost:8888/api/v1/upload?${stringifiedParams}` : `http://localhost:8888/api/v1/upload`
}

export const uploadFileApiV1 = async (params: UploadFileApiV1Params, options?: RequestInit): Promise<uploadFileApiV1Response> => {
  
  return apiClient<uploadFileApiV1Response>(getUploadFileApiV1Url(params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getUploadFileApiV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadFileApiV1>>, TError,{params: UploadFileApiV1Params}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadFileApiV1>>, TError,{params: UploadFileApiV1Params}, TContext> => {
    
const mutationKey = ['uploadFileApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadFileApiV1>>, {params: UploadFileApiV1Params}> = (props) => {
          const {params} = props ?? {};

          return  uploadFileApiV1(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadFileApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof uploadFileApiV1>>>
    
    export type UploadFileApiV1MutationError = unknown

    export const useUploadFileApiV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadFileApiV1>>, TError,{params: UploadFileApiV1Params}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof uploadFileApiV1>>,
        TError,
        {params: UploadFileApiV1Params},
        TContext
      > => {

      const mutationOptions = getUploadFileApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export type getPayoutHistoryApiV1Response200 = {
  data: GetPayoutHistoryResponseDto
  status: 200
}
    
export type getPayoutHistoryApiV1ResponseComposite = getPayoutHistoryApiV1Response200;
    
export type getPayoutHistoryApiV1Response = getPayoutHistoryApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetPayoutHistoryApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/payout/withdrawals`
}

export const getPayoutHistoryApiV1 = async (workspaceId: string, options?: RequestInit): Promise<getPayoutHistoryApiV1Response> => {
  
  return apiClient<getPayoutHistoryApiV1Response>(getGetPayoutHistoryApiV1Url(workspaceId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetPayoutHistoryApiV1QueryKey = (workspaceId: string,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/payout/withdrawals`] as const;
    }

    
export const getGetPayoutHistoryApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getPayoutHistoryApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutHistoryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayoutHistoryApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayoutHistoryApiV1>>> = ({ signal }) => getPayoutHistoryApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayoutHistoryApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayoutHistoryApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getPayoutHistoryApiV1>>>
export type GetPayoutHistoryApiV1QueryError = unknown


export function useGetPayoutHistoryApiV1<TData = Awaited<ReturnType<typeof getPayoutHistoryApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutHistoryApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayoutHistoryApiV1>>,
          TError,
          Awaited<ReturnType<typeof getPayoutHistoryApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayoutHistoryApiV1<TData = Awaited<ReturnType<typeof getPayoutHistoryApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutHistoryApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayoutHistoryApiV1>>,
          TError,
          Awaited<ReturnType<typeof getPayoutHistoryApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayoutHistoryApiV1<TData = Awaited<ReturnType<typeof getPayoutHistoryApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutHistoryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPayoutHistoryApiV1<TData = Awaited<ReturnType<typeof getPayoutHistoryApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutHistoryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayoutHistoryApiV1QueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetPayoutHistoryApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPayoutHistoryApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPayoutHistoryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayoutHistoryApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayoutHistoryApiV1>>> = ({ signal }) => getPayoutHistoryApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPayoutHistoryApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayoutHistoryApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPayoutHistoryApiV1>>>
export type GetPayoutHistoryApiV1SuspenseQueryError = unknown


export function useGetPayoutHistoryApiV1Suspense<TData = Awaited<ReturnType<typeof getPayoutHistoryApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPayoutHistoryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayoutHistoryApiV1Suspense<TData = Awaited<ReturnType<typeof getPayoutHistoryApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPayoutHistoryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayoutHistoryApiV1Suspense<TData = Awaited<ReturnType<typeof getPayoutHistoryApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPayoutHistoryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPayoutHistoryApiV1Suspense<TData = Awaited<ReturnType<typeof getPayoutHistoryApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPayoutHistoryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayoutHistoryApiV1SuspenseQueryOptions(workspaceId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type requestWithdrawalApiV1Response201 = {
  data: void
  status: 201
}

export type requestWithdrawalApiV1Response422 = {
  data: void
  status: 422
}
    
export type requestWithdrawalApiV1ResponseComposite = requestWithdrawalApiV1Response201 | requestWithdrawalApiV1Response422;
    
export type requestWithdrawalApiV1Response = requestWithdrawalApiV1ResponseComposite & {
  headers: Headers;
}

export const getRequestWithdrawalApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/payout/withdrawals`
}

export const requestWithdrawalApiV1 = async (workspaceId: string, options?: RequestInit): Promise<requestWithdrawalApiV1Response> => {
  
  return apiClient<requestWithdrawalApiV1Response>(getRequestWithdrawalApiV1Url(workspaceId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getRequestWithdrawalApiV1MutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestWithdrawalApiV1>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof requestWithdrawalApiV1>>, TError,{workspaceId: string}, TContext> => {
    
const mutationKey = ['requestWithdrawalApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestWithdrawalApiV1>>, {workspaceId: string}> = (props) => {
          const {workspaceId} = props ?? {};

          return  requestWithdrawalApiV1(workspaceId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RequestWithdrawalApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof requestWithdrawalApiV1>>>
    
    export type RequestWithdrawalApiV1MutationError = void

    export const useRequestWithdrawalApiV1 = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestWithdrawalApiV1>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof requestWithdrawalApiV1>>,
        TError,
        {workspaceId: string},
        TContext
      > => {

      const mutationOptions = getRequestWithdrawalApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export type handleTrolleyPaymentStatusApiV1Response204 = {
  data: void
  status: 204
}
    
export type handleTrolleyPaymentStatusApiV1ResponseComposite = handleTrolleyPaymentStatusApiV1Response204;
    
export type handleTrolleyPaymentStatusApiV1Response = handleTrolleyPaymentStatusApiV1ResponseComposite & {
  headers: Headers;
}

export const getHandleTrolleyPaymentStatusApiV1Url = (workspaceId: unknown,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/payout/webhook/trolley`
}

export const handleTrolleyPaymentStatusApiV1 = async (workspaceId: unknown, options?: RequestInit): Promise<handleTrolleyPaymentStatusApiV1Response> => {
  
  return apiClient<handleTrolleyPaymentStatusApiV1Response>(getHandleTrolleyPaymentStatusApiV1Url(workspaceId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getHandleTrolleyPaymentStatusApiV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handleTrolleyPaymentStatusApiV1>>, TError,{workspaceId: unknown}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof handleTrolleyPaymentStatusApiV1>>, TError,{workspaceId: unknown}, TContext> => {
    
const mutationKey = ['handleTrolleyPaymentStatusApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof handleTrolleyPaymentStatusApiV1>>, {workspaceId: unknown}> = (props) => {
          const {workspaceId} = props ?? {};

          return  handleTrolleyPaymentStatusApiV1(workspaceId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HandleTrolleyPaymentStatusApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof handleTrolleyPaymentStatusApiV1>>>
    
    export type HandleTrolleyPaymentStatusApiV1MutationError = unknown

    export const useHandleTrolleyPaymentStatusApiV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handleTrolleyPaymentStatusApiV1>>, TError,{workspaceId: unknown}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof handleTrolleyPaymentStatusApiV1>>,
        TError,
        {workspaceId: unknown},
        TContext
      > => {

      const mutationOptions = getHandleTrolleyPaymentStatusApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export type resetTestSettlementApiV1Response201 = {
  data: void
  status: 201
}
    
export type resetTestSettlementApiV1ResponseComposite = resetTestSettlementApiV1Response201;
    
export type resetTestSettlementApiV1Response = resetTestSettlementApiV1ResponseComposite & {
  headers: Headers;
}

export const getResetTestSettlementApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/payout/reset/test-settlement`
}

export const resetTestSettlementApiV1 = async (workspaceId: string, options?: RequestInit): Promise<resetTestSettlementApiV1Response> => {
  
  return apiClient<resetTestSettlementApiV1Response>(getResetTestSettlementApiV1Url(workspaceId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getResetTestSettlementApiV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetTestSettlementApiV1>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof resetTestSettlementApiV1>>, TError,{workspaceId: string}, TContext> => {
    
const mutationKey = ['resetTestSettlementApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetTestSettlementApiV1>>, {workspaceId: string}> = (props) => {
          const {workspaceId} = props ?? {};

          return  resetTestSettlementApiV1(workspaceId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResetTestSettlementApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof resetTestSettlementApiV1>>>
    
    export type ResetTestSettlementApiV1MutationError = unknown

    export const useResetTestSettlementApiV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetTestSettlementApiV1>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof resetTestSettlementApiV1>>,
        TError,
        {workspaceId: string},
        TContext
      > => {

      const mutationOptions = getResetTestSettlementApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export type getMusicsApiV1Response200 = {
  data: PaginatedMusicsResponseDto
  status: 200
}
    
export type getMusicsApiV1ResponseComposite = getMusicsApiV1Response200;
    
export type getMusicsApiV1Response = getMusicsApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetMusicsApiV1Url = (params?: GetMusicsApiV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `http://localhost:8888/api/v1/musics?${stringifiedParams}` : `http://localhost:8888/api/v1/musics`
}

export const getMusicsApiV1 = async (params?: GetMusicsApiV1Params, options?: RequestInit): Promise<getMusicsApiV1Response> => {
  
  return apiClient<getMusicsApiV1Response>(getGetMusicsApiV1Url(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetMusicsApiV1QueryKey = (params?: GetMusicsApiV1Params,) => {
    return [`http://localhost:8888/api/v1/musics`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMusicsApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getMusicsApiV1>>, TError = unknown>(params?: GetMusicsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMusicsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMusicsApiV1QueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMusicsApiV1>>> = ({ signal }) => getMusicsApiV1(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMusicsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMusicsApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getMusicsApiV1>>>
export type GetMusicsApiV1QueryError = unknown


export function useGetMusicsApiV1<TData = Awaited<ReturnType<typeof getMusicsApiV1>>, TError = unknown>(
 params: undefined |  GetMusicsApiV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMusicsApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMusicsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getMusicsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMusicsApiV1<TData = Awaited<ReturnType<typeof getMusicsApiV1>>, TError = unknown>(
 params?: GetMusicsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMusicsApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMusicsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getMusicsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMusicsApiV1<TData = Awaited<ReturnType<typeof getMusicsApiV1>>, TError = unknown>(
 params?: GetMusicsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMusicsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMusicsApiV1<TData = Awaited<ReturnType<typeof getMusicsApiV1>>, TError = unknown>(
 params?: GetMusicsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMusicsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMusicsApiV1QueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetMusicsApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMusicsApiV1>>, TError = unknown>(params?: GetMusicsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMusicsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMusicsApiV1QueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMusicsApiV1>>> = ({ signal }) => getMusicsApiV1(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMusicsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMusicsApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMusicsApiV1>>>
export type GetMusicsApiV1SuspenseQueryError = unknown


export function useGetMusicsApiV1Suspense<TData = Awaited<ReturnType<typeof getMusicsApiV1>>, TError = unknown>(
 params: undefined |  GetMusicsApiV1Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMusicsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMusicsApiV1Suspense<TData = Awaited<ReturnType<typeof getMusicsApiV1>>, TError = unknown>(
 params?: GetMusicsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMusicsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMusicsApiV1Suspense<TData = Awaited<ReturnType<typeof getMusicsApiV1>>, TError = unknown>(
 params?: GetMusicsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMusicsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMusicsApiV1Suspense<TData = Awaited<ReturnType<typeof getMusicsApiV1>>, TError = unknown>(
 params?: GetMusicsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMusicsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMusicsApiV1SuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type getMoodsApiV1Response200 = {
  data: GetMoodResponseDto
  status: 200
}
    
export type getMoodsApiV1ResponseComposite = getMoodsApiV1Response200;
    
export type getMoodsApiV1Response = getMoodsApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetMoodsApiV1Url = () => {


  

  return `http://localhost:8888/api/v1/musics/moods`
}

export const getMoodsApiV1 = async ( options?: RequestInit): Promise<getMoodsApiV1Response> => {
  
  return apiClient<getMoodsApiV1Response>(getGetMoodsApiV1Url(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetMoodsApiV1QueryKey = () => {
    return [`http://localhost:8888/api/v1/musics/moods`] as const;
    }

    
export const getGetMoodsApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getMoodsApiV1>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMoodsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMoodsApiV1QueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMoodsApiV1>>> = ({ signal }) => getMoodsApiV1({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMoodsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMoodsApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getMoodsApiV1>>>
export type GetMoodsApiV1QueryError = unknown


export function useGetMoodsApiV1<TData = Awaited<ReturnType<typeof getMoodsApiV1>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMoodsApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMoodsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getMoodsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMoodsApiV1<TData = Awaited<ReturnType<typeof getMoodsApiV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMoodsApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMoodsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getMoodsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMoodsApiV1<TData = Awaited<ReturnType<typeof getMoodsApiV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMoodsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMoodsApiV1<TData = Awaited<ReturnType<typeof getMoodsApiV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMoodsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMoodsApiV1QueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetMoodsApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMoodsApiV1>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMoodsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMoodsApiV1QueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMoodsApiV1>>> = ({ signal }) => getMoodsApiV1({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMoodsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMoodsApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMoodsApiV1>>>
export type GetMoodsApiV1SuspenseQueryError = unknown


export function useGetMoodsApiV1Suspense<TData = Awaited<ReturnType<typeof getMoodsApiV1>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMoodsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMoodsApiV1Suspense<TData = Awaited<ReturnType<typeof getMoodsApiV1>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMoodsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMoodsApiV1Suspense<TData = Awaited<ReturnType<typeof getMoodsApiV1>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMoodsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMoodsApiV1Suspense<TData = Awaited<ReturnType<typeof getMoodsApiV1>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMoodsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMoodsApiV1SuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type favoriteMusicApiV1Response200 = {
  data: void
  status: 200
}
    
export type favoriteMusicApiV1ResponseComposite = favoriteMusicApiV1Response200;
    
export type favoriteMusicApiV1Response = favoriteMusicApiV1ResponseComposite & {
  headers: Headers;
}

export const getFavoriteMusicApiV1Url = () => {


  

  return `http://localhost:8888/api/v1/musics/favorite`
}

export const favoriteMusicApiV1 = async (favoriteMusicRequestDto: FavoriteMusicRequestDto, options?: RequestInit): Promise<favoriteMusicApiV1Response> => {
  
  return apiClient<favoriteMusicApiV1Response>(getFavoriteMusicApiV1Url(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      favoriteMusicRequestDto,)
  }
);}




export const getFavoriteMusicApiV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof favoriteMusicApiV1>>, TError,{data: FavoriteMusicRequestDto}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof favoriteMusicApiV1>>, TError,{data: FavoriteMusicRequestDto}, TContext> => {
    
const mutationKey = ['favoriteMusicApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof favoriteMusicApiV1>>, {data: FavoriteMusicRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  favoriteMusicApiV1(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FavoriteMusicApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof favoriteMusicApiV1>>>
    export type FavoriteMusicApiV1MutationBody = FavoriteMusicRequestDto
    export type FavoriteMusicApiV1MutationError = unknown

    export const useFavoriteMusicApiV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof favoriteMusicApiV1>>, TError,{data: FavoriteMusicRequestDto}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof favoriteMusicApiV1>>,
        TError,
        {data: FavoriteMusicRequestDto},
        TContext
      > => {

      const mutationOptions = getFavoriteMusicApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export type unfavoriteMusicApiV1Response200 = {
  data: void
  status: 200
}
    
export type unfavoriteMusicApiV1ResponseComposite = unfavoriteMusicApiV1Response200;
    
export type unfavoriteMusicApiV1Response = unfavoriteMusicApiV1ResponseComposite & {
  headers: Headers;
}

export const getUnfavoriteMusicApiV1Url = () => {


  

  return `http://localhost:8888/api/v1/musics/unfavorite`
}

export const unfavoriteMusicApiV1 = async (favoriteMusicRequestDto: FavoriteMusicRequestDto, options?: RequestInit): Promise<unfavoriteMusicApiV1Response> => {
  
  return apiClient<unfavoriteMusicApiV1Response>(getUnfavoriteMusicApiV1Url(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      favoriteMusicRequestDto,)
  }
);}




export const getUnfavoriteMusicApiV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unfavoriteMusicApiV1>>, TError,{data: FavoriteMusicRequestDto}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof unfavoriteMusicApiV1>>, TError,{data: FavoriteMusicRequestDto}, TContext> => {
    
const mutationKey = ['unfavoriteMusicApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unfavoriteMusicApiV1>>, {data: FavoriteMusicRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  unfavoriteMusicApiV1(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UnfavoriteMusicApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof unfavoriteMusicApiV1>>>
    export type UnfavoriteMusicApiV1MutationBody = FavoriteMusicRequestDto
    export type UnfavoriteMusicApiV1MutationError = unknown

    export const useUnfavoriteMusicApiV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unfavoriteMusicApiV1>>, TError,{data: FavoriteMusicRequestDto}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof unfavoriteMusicApiV1>>,
        TError,
        {data: FavoriteMusicRequestDto},
        TContext
      > => {

      const mutationOptions = getUnfavoriteMusicApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export type getChannelsApiV1Response200 = {
  data: GetChannelsResponseDto
  status: 200
}
    
export type getChannelsApiV1ResponseComposite = getChannelsApiV1Response200;
    
export type getChannelsApiV1Response = getChannelsApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetChannelsApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/channels`
}

export const getChannelsApiV1 = async (workspaceId: string, options?: RequestInit): Promise<getChannelsApiV1Response> => {
  
  return apiClient<getChannelsApiV1Response>(getGetChannelsApiV1Url(workspaceId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetChannelsApiV1QueryKey = (workspaceId: string,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/channels`] as const;
    }

    
export const getGetChannelsApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getChannelsApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChannelsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChannelsApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChannelsApiV1>>> = ({ signal }) => getChannelsApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChannelsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetChannelsApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getChannelsApiV1>>>
export type GetChannelsApiV1QueryError = unknown


export function useGetChannelsApiV1<TData = Awaited<ReturnType<typeof getChannelsApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChannelsApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChannelsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getChannelsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChannelsApiV1<TData = Awaited<ReturnType<typeof getChannelsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChannelsApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChannelsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getChannelsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChannelsApiV1<TData = Awaited<ReturnType<typeof getChannelsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChannelsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetChannelsApiV1<TData = Awaited<ReturnType<typeof getChannelsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChannelsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChannelsApiV1QueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetChannelsApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getChannelsApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChannelsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChannelsApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChannelsApiV1>>> = ({ signal }) => getChannelsApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChannelsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetChannelsApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getChannelsApiV1>>>
export type GetChannelsApiV1SuspenseQueryError = unknown


export function useGetChannelsApiV1Suspense<TData = Awaited<ReturnType<typeof getChannelsApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChannelsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChannelsApiV1Suspense<TData = Awaited<ReturnType<typeof getChannelsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChannelsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChannelsApiV1Suspense<TData = Awaited<ReturnType<typeof getChannelsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChannelsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetChannelsApiV1Suspense<TData = Awaited<ReturnType<typeof getChannelsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChannelsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChannelsApiV1SuspenseQueryOptions(workspaceId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type addYoutubeChannelApiV1Response200 = {
  data: AddYoutubeChannelResponseDto
  status: 200
}

export type addYoutubeChannelApiV1Response401 = {
  data: void
  status: 401
}
    
export type addYoutubeChannelApiV1ResponseComposite = addYoutubeChannelApiV1Response200 | addYoutubeChannelApiV1Response401;
    
export type addYoutubeChannelApiV1Response = addYoutubeChannelApiV1ResponseComposite & {
  headers: Headers;
}

export const getAddYoutubeChannelApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/channels`
}

export const addYoutubeChannelApiV1 = async (workspaceId: string,
    addYoutubeChannelRequestDto: AddYoutubeChannelRequestDto, options?: RequestInit): Promise<addYoutubeChannelApiV1Response> => {
  
  return apiClient<addYoutubeChannelApiV1Response>(getAddYoutubeChannelApiV1Url(workspaceId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addYoutubeChannelRequestDto,)
  }
);}




export const getAddYoutubeChannelApiV1MutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addYoutubeChannelApiV1>>, TError,{workspaceId: string;data: AddYoutubeChannelRequestDto}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof addYoutubeChannelApiV1>>, TError,{workspaceId: string;data: AddYoutubeChannelRequestDto}, TContext> => {
    
const mutationKey = ['addYoutubeChannelApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addYoutubeChannelApiV1>>, {workspaceId: string;data: AddYoutubeChannelRequestDto}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  addYoutubeChannelApiV1(workspaceId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddYoutubeChannelApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof addYoutubeChannelApiV1>>>
    export type AddYoutubeChannelApiV1MutationBody = AddYoutubeChannelRequestDto
    export type AddYoutubeChannelApiV1MutationError = void

    export const useAddYoutubeChannelApiV1 = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addYoutubeChannelApiV1>>, TError,{workspaceId: string;data: AddYoutubeChannelRequestDto}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof addYoutubeChannelApiV1>>,
        TError,
        {workspaceId: string;data: AddYoutubeChannelRequestDto},
        TContext
      > => {

      const mutationOptions = getAddYoutubeChannelApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export type deleteChannelApiV1Response204 = {
  data: void
  status: 204
}
    
export type deleteChannelApiV1ResponseComposite = deleteChannelApiV1Response204;
    
export type deleteChannelApiV1Response = deleteChannelApiV1ResponseComposite & {
  headers: Headers;
}

export const getDeleteChannelApiV1Url = (workspaceId: string,
    channelId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/channels/${channelId}`
}

export const deleteChannelApiV1 = async (workspaceId: string,
    channelId: string, options?: RequestInit): Promise<deleteChannelApiV1Response> => {
  
  return apiClient<deleteChannelApiV1Response>(getDeleteChannelApiV1Url(workspaceId,channelId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getDeleteChannelApiV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteChannelApiV1>>, TError,{workspaceId: string;channelId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteChannelApiV1>>, TError,{workspaceId: string;channelId: string}, TContext> => {
    
const mutationKey = ['deleteChannelApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteChannelApiV1>>, {workspaceId: string;channelId: string}> = (props) => {
          const {workspaceId,channelId} = props ?? {};

          return  deleteChannelApiV1(workspaceId,channelId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteChannelApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof deleteChannelApiV1>>>
    
    export type DeleteChannelApiV1MutationError = unknown

    export const useDeleteChannelApiV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteChannelApiV1>>, TError,{workspaceId: string;channelId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteChannelApiV1>>,
        TError,
        {workspaceId: string;channelId: string},
        TContext
      > => {

      const mutationOptions = getDeleteChannelApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Verify a YouTube channel
 */
export type verifyYoutubeChannelApiV1Response200 = {
  data: AddYoutubeChannelResponseDto
  status: 200
}

export type verifyYoutubeChannelApiV1Response400 = {
  data: void
  status: 400
}
    
export type verifyYoutubeChannelApiV1ResponseComposite = verifyYoutubeChannelApiV1Response200 | verifyYoutubeChannelApiV1Response400;
    
export type verifyYoutubeChannelApiV1Response = verifyYoutubeChannelApiV1ResponseComposite & {
  headers: Headers;
}

export const getVerifyYoutubeChannelApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/channels/verify`
}

export const verifyYoutubeChannelApiV1 = async (workspaceId: string,
    verifyYoutubeChannelRequestDto: VerifyYoutubeChannelRequestDto, options?: RequestInit): Promise<verifyYoutubeChannelApiV1Response> => {
  
  return apiClient<verifyYoutubeChannelApiV1Response>(getVerifyYoutubeChannelApiV1Url(workspaceId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      verifyYoutubeChannelRequestDto,)
  }
);}




export const getVerifyYoutubeChannelApiV1MutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyYoutubeChannelApiV1>>, TError,{workspaceId: string;data: VerifyYoutubeChannelRequestDto}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyYoutubeChannelApiV1>>, TError,{workspaceId: string;data: VerifyYoutubeChannelRequestDto}, TContext> => {
    
const mutationKey = ['verifyYoutubeChannelApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyYoutubeChannelApiV1>>, {workspaceId: string;data: VerifyYoutubeChannelRequestDto}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  verifyYoutubeChannelApiV1(workspaceId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerifyYoutubeChannelApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof verifyYoutubeChannelApiV1>>>
    export type VerifyYoutubeChannelApiV1MutationBody = VerifyYoutubeChannelRequestDto
    export type VerifyYoutubeChannelApiV1MutationError = void

    /**
 * @summary Verify a YouTube channel
 */
export const useVerifyYoutubeChannelApiV1 = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyYoutubeChannelApiV1>>, TError,{workspaceId: string;data: VerifyYoutubeChannelRequestDto}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof verifyYoutubeChannelApiV1>>,
        TError,
        {workspaceId: string;data: VerifyYoutubeChannelRequestDto},
        TContext
      > => {

      const mutationOptions = getVerifyYoutubeChannelApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Check a YouTube channel
 */
export type checkYoutubeChannelApiV1Response200 = {
  data: CheckYoutubeChannelResponseDto
  status: 200
}

export type checkYoutubeChannelApiV1Response400 = {
  data: void
  status: 400
}
    
export type checkYoutubeChannelApiV1ResponseComposite = checkYoutubeChannelApiV1Response200 | checkYoutubeChannelApiV1Response400;
    
export type checkYoutubeChannelApiV1Response = checkYoutubeChannelApiV1ResponseComposite & {
  headers: Headers;
}

export const getCheckYoutubeChannelApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/channels/check`
}

export const checkYoutubeChannelApiV1 = async (workspaceId: string,
    checkYoutubeChannelRequestDto: CheckYoutubeChannelRequestDto, options?: RequestInit): Promise<checkYoutubeChannelApiV1Response> => {
  
  return apiClient<checkYoutubeChannelApiV1Response>(getCheckYoutubeChannelApiV1Url(workspaceId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      checkYoutubeChannelRequestDto,)
  }
);}




export const getCheckYoutubeChannelApiV1MutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkYoutubeChannelApiV1>>, TError,{workspaceId: string;data: CheckYoutubeChannelRequestDto}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkYoutubeChannelApiV1>>, TError,{workspaceId: string;data: CheckYoutubeChannelRequestDto}, TContext> => {
    
const mutationKey = ['checkYoutubeChannelApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkYoutubeChannelApiV1>>, {workspaceId: string;data: CheckYoutubeChannelRequestDto}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  checkYoutubeChannelApiV1(workspaceId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CheckYoutubeChannelApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof checkYoutubeChannelApiV1>>>
    export type CheckYoutubeChannelApiV1MutationBody = CheckYoutubeChannelRequestDto
    export type CheckYoutubeChannelApiV1MutationError = void

    /**
 * @summary Check a YouTube channel
 */
export const useCheckYoutubeChannelApiV1 = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkYoutubeChannelApiV1>>, TError,{workspaceId: string;data: CheckYoutubeChannelRequestDto}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof checkYoutubeChannelApiV1>>,
        TError,
        {workspaceId: string;data: CheckYoutubeChannelRequestDto},
        TContext
      > => {

      const mutationOptions = getCheckYoutubeChannelApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export type registerTiktokChannelApiV1Response201 = {
  data: void
  status: 201
}
    
export type registerTiktokChannelApiV1ResponseComposite = registerTiktokChannelApiV1Response201;
    
export type registerTiktokChannelApiV1Response = registerTiktokChannelApiV1ResponseComposite & {
  headers: Headers;
}

export const getRegisterTiktokChannelApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/channels/tiktok/register`
}

export const registerTiktokChannelApiV1 = async (workspaceId: string, options?: RequestInit): Promise<registerTiktokChannelApiV1Response> => {
  
  return apiClient<registerTiktokChannelApiV1Response>(getRegisterTiktokChannelApiV1Url(workspaceId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getRegisterTiktokChannelApiV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerTiktokChannelApiV1>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof registerTiktokChannelApiV1>>, TError,{workspaceId: string}, TContext> => {
    
const mutationKey = ['registerTiktokChannelApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerTiktokChannelApiV1>>, {workspaceId: string}> = (props) => {
          const {workspaceId} = props ?? {};

          return  registerTiktokChannelApiV1(workspaceId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RegisterTiktokChannelApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof registerTiktokChannelApiV1>>>
    
    export type RegisterTiktokChannelApiV1MutationError = unknown

    export const useRegisterTiktokChannelApiV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerTiktokChannelApiV1>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof registerTiktokChannelApiV1>>,
        TError,
        {workspaceId: string},
        TContext
      > => {

      const mutationOptions = getRegisterTiktokChannelApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export type unregisterTiktokChannelApiV1Response201 = {
  data: void
  status: 201
}
    
export type unregisterTiktokChannelApiV1ResponseComposite = unregisterTiktokChannelApiV1Response201;
    
export type unregisterTiktokChannelApiV1Response = unregisterTiktokChannelApiV1ResponseComposite & {
  headers: Headers;
}

export const getUnregisterTiktokChannelApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/channels/tiktok/unregister`
}

export const unregisterTiktokChannelApiV1 = async (workspaceId: string, options?: RequestInit): Promise<unregisterTiktokChannelApiV1Response> => {
  
  return apiClient<unregisterTiktokChannelApiV1Response>(getUnregisterTiktokChannelApiV1Url(workspaceId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getUnregisterTiktokChannelApiV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unregisterTiktokChannelApiV1>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof unregisterTiktokChannelApiV1>>, TError,{workspaceId: string}, TContext> => {
    
const mutationKey = ['unregisterTiktokChannelApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unregisterTiktokChannelApiV1>>, {workspaceId: string}> = (props) => {
          const {workspaceId} = props ?? {};

          return  unregisterTiktokChannelApiV1(workspaceId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UnregisterTiktokChannelApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof unregisterTiktokChannelApiV1>>>
    
    export type UnregisterTiktokChannelApiV1MutationError = unknown

    export const useUnregisterTiktokChannelApiV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unregisterTiktokChannelApiV1>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof unregisterTiktokChannelApiV1>>,
        TError,
        {workspaceId: string},
        TContext
      > => {

      const mutationOptions = getUnregisterTiktokChannelApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export type registerInstagramChannelApiV1Response201 = {
  data: void
  status: 201
}
    
export type registerInstagramChannelApiV1ResponseComposite = registerInstagramChannelApiV1Response201;
    
export type registerInstagramChannelApiV1Response = registerInstagramChannelApiV1ResponseComposite & {
  headers: Headers;
}

export const getRegisterInstagramChannelApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/channels/instagram/register`
}

export const registerInstagramChannelApiV1 = async (workspaceId: string,
    registerInstagramChannelRequestDto: RegisterInstagramChannelRequestDto, options?: RequestInit): Promise<registerInstagramChannelApiV1Response> => {
  
  return apiClient<registerInstagramChannelApiV1Response>(getRegisterInstagramChannelApiV1Url(workspaceId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      registerInstagramChannelRequestDto,)
  }
);}




export const getRegisterInstagramChannelApiV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerInstagramChannelApiV1>>, TError,{workspaceId: string;data: RegisterInstagramChannelRequestDto}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof registerInstagramChannelApiV1>>, TError,{workspaceId: string;data: RegisterInstagramChannelRequestDto}, TContext> => {
    
const mutationKey = ['registerInstagramChannelApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerInstagramChannelApiV1>>, {workspaceId: string;data: RegisterInstagramChannelRequestDto}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  registerInstagramChannelApiV1(workspaceId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RegisterInstagramChannelApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof registerInstagramChannelApiV1>>>
    export type RegisterInstagramChannelApiV1MutationBody = RegisterInstagramChannelRequestDto
    export type RegisterInstagramChannelApiV1MutationError = unknown

    export const useRegisterInstagramChannelApiV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerInstagramChannelApiV1>>, TError,{workspaceId: string;data: RegisterInstagramChannelRequestDto}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof registerInstagramChannelApiV1>>,
        TError,
        {workspaceId: string;data: RegisterInstagramChannelRequestDto},
        TContext
      > => {

      const mutationOptions = getRegisterInstagramChannelApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export type unregisterInstagramChannelApiV1Response201 = {
  data: void
  status: 201
}
    
export type unregisterInstagramChannelApiV1ResponseComposite = unregisterInstagramChannelApiV1Response201;
    
export type unregisterInstagramChannelApiV1Response = unregisterInstagramChannelApiV1ResponseComposite & {
  headers: Headers;
}

export const getUnregisterInstagramChannelApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/channels/instagram/unregister`
}

export const unregisterInstagramChannelApiV1 = async (workspaceId: string, options?: RequestInit): Promise<unregisterInstagramChannelApiV1Response> => {
  
  return apiClient<unregisterInstagramChannelApiV1Response>(getUnregisterInstagramChannelApiV1Url(workspaceId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getUnregisterInstagramChannelApiV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unregisterInstagramChannelApiV1>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof unregisterInstagramChannelApiV1>>, TError,{workspaceId: string}, TContext> => {
    
const mutationKey = ['unregisterInstagramChannelApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unregisterInstagramChannelApiV1>>, {workspaceId: string}> = (props) => {
          const {workspaceId} = props ?? {};

          return  unregisterInstagramChannelApiV1(workspaceId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UnregisterInstagramChannelApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof unregisterInstagramChannelApiV1>>>
    
    export type UnregisterInstagramChannelApiV1MutationError = unknown

    export const useUnregisterInstagramChannelApiV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unregisterInstagramChannelApiV1>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof unregisterInstagramChannelApiV1>>,
        TError,
        {workspaceId: string},
        TContext
      > => {

      const mutationOptions = getUnregisterInstagramChannelApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export type getChannelAnalyticsApiV1Response200 = {
  data: GetChannelAnalyticsResponseDto
  status: 200
}
    
export type getChannelAnalyticsApiV1ResponseComposite = getChannelAnalyticsApiV1Response200;
    
export type getChannelAnalyticsApiV1Response = getChannelAnalyticsApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetChannelAnalyticsApiV1Url = (workspaceId: unknown,
    channelId: string,
    params?: GetChannelAnalyticsApiV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/channels/${channelId}?${stringifiedParams}` : `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/channels/${channelId}`
}

export const getChannelAnalyticsApiV1 = async (workspaceId: unknown,
    channelId: string,
    params?: GetChannelAnalyticsApiV1Params, options?: RequestInit): Promise<getChannelAnalyticsApiV1Response> => {
  
  return apiClient<getChannelAnalyticsApiV1Response>(getGetChannelAnalyticsApiV1Url(workspaceId,channelId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetChannelAnalyticsApiV1QueryKey = (workspaceId: unknown,
    channelId: string,
    params?: GetChannelAnalyticsApiV1Params,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/channels/${channelId}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetChannelAnalyticsApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>, TError = unknown>(workspaceId: unknown,
    channelId: string,
    params?: GetChannelAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChannelAnalyticsApiV1QueryKey(workspaceId,channelId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>> = ({ signal }) => getChannelAnalyticsApiV1(workspaceId,channelId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && channelId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetChannelAnalyticsApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>>
export type GetChannelAnalyticsApiV1QueryError = unknown


export function useGetChannelAnalyticsApiV1<TData = Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>, TError = unknown>(
 workspaceId: unknown,
    channelId: string,
    params: undefined |  GetChannelAnalyticsApiV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChannelAnalyticsApiV1<TData = Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>, TError = unknown>(
 workspaceId: unknown,
    channelId: string,
    params?: GetChannelAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChannelAnalyticsApiV1<TData = Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>, TError = unknown>(
 workspaceId: unknown,
    channelId: string,
    params?: GetChannelAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetChannelAnalyticsApiV1<TData = Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>, TError = unknown>(
 workspaceId: unknown,
    channelId: string,
    params?: GetChannelAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChannelAnalyticsApiV1QueryOptions(workspaceId,channelId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetChannelAnalyticsApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>, TError = unknown>(workspaceId: unknown,
    channelId: string,
    params?: GetChannelAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChannelAnalyticsApiV1QueryKey(workspaceId,channelId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>> = ({ signal }) => getChannelAnalyticsApiV1(workspaceId,channelId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetChannelAnalyticsApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>>
export type GetChannelAnalyticsApiV1SuspenseQueryError = unknown


export function useGetChannelAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>, TError = unknown>(
 workspaceId: unknown,
    channelId: string,
    params: undefined |  GetChannelAnalyticsApiV1Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChannelAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>, TError = unknown>(
 workspaceId: unknown,
    channelId: string,
    params?: GetChannelAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChannelAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>, TError = unknown>(
 workspaceId: unknown,
    channelId: string,
    params?: GetChannelAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetChannelAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>, TError = unknown>(
 workspaceId: unknown,
    channelId: string,
    params?: GetChannelAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChannelAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChannelAnalyticsApiV1SuspenseQueryOptions(workspaceId,channelId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type getChannelVideosAnalyticsApiV1Response200 = {
  data: GetChannelVideosSummaryAnalyticsResponseDto
  status: 200
}
    
export type getChannelVideosAnalyticsApiV1ResponseComposite = getChannelVideosAnalyticsApiV1Response200;
    
export type getChannelVideosAnalyticsApiV1Response = getChannelVideosAnalyticsApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetChannelVideosAnalyticsApiV1Url = (workspaceId: unknown,
    channelId: string,
    params: GetChannelVideosAnalyticsApiV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/channels/${channelId}/videos/summary?${stringifiedParams}` : `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/channels/${channelId}/videos/summary`
}

export const getChannelVideosAnalyticsApiV1 = async (workspaceId: unknown,
    channelId: string,
    params: GetChannelVideosAnalyticsApiV1Params, options?: RequestInit): Promise<getChannelVideosAnalyticsApiV1Response> => {
  
  return apiClient<getChannelVideosAnalyticsApiV1Response>(getGetChannelVideosAnalyticsApiV1Url(workspaceId,channelId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetChannelVideosAnalyticsApiV1QueryKey = (workspaceId: unknown,
    channelId: string,
    params: GetChannelVideosAnalyticsApiV1Params,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/channels/${channelId}/videos/summary`, ...(params ? [params]: [])] as const;
    }

    
export const getGetChannelVideosAnalyticsApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>, TError = unknown>(workspaceId: unknown,
    channelId: string,
    params: GetChannelVideosAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChannelVideosAnalyticsApiV1QueryKey(workspaceId,channelId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>> = ({ signal }) => getChannelVideosAnalyticsApiV1(workspaceId,channelId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && channelId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetChannelVideosAnalyticsApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>>
export type GetChannelVideosAnalyticsApiV1QueryError = unknown


export function useGetChannelVideosAnalyticsApiV1<TData = Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>, TError = unknown>(
 workspaceId: unknown,
    channelId: string,
    params: GetChannelVideosAnalyticsApiV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChannelVideosAnalyticsApiV1<TData = Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>, TError = unknown>(
 workspaceId: unknown,
    channelId: string,
    params: GetChannelVideosAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChannelVideosAnalyticsApiV1<TData = Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>, TError = unknown>(
 workspaceId: unknown,
    channelId: string,
    params: GetChannelVideosAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetChannelVideosAnalyticsApiV1<TData = Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>, TError = unknown>(
 workspaceId: unknown,
    channelId: string,
    params: GetChannelVideosAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChannelVideosAnalyticsApiV1QueryOptions(workspaceId,channelId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetChannelVideosAnalyticsApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>, TError = unknown>(workspaceId: unknown,
    channelId: string,
    params: GetChannelVideosAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChannelVideosAnalyticsApiV1QueryKey(workspaceId,channelId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>> = ({ signal }) => getChannelVideosAnalyticsApiV1(workspaceId,channelId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetChannelVideosAnalyticsApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>>
export type GetChannelVideosAnalyticsApiV1SuspenseQueryError = unknown


export function useGetChannelVideosAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>, TError = unknown>(
 workspaceId: unknown,
    channelId: string,
    params: GetChannelVideosAnalyticsApiV1Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChannelVideosAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>, TError = unknown>(
 workspaceId: unknown,
    channelId: string,
    params: GetChannelVideosAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChannelVideosAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>, TError = unknown>(
 workspaceId: unknown,
    channelId: string,
    params: GetChannelVideosAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetChannelVideosAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>, TError = unknown>(
 workspaceId: unknown,
    channelId: string,
    params: GetChannelVideosAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChannelVideosAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChannelVideosAnalyticsApiV1SuspenseQueryOptions(workspaceId,channelId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type getAvailableDataUntilApiV1Response200 = {
  data: GetAvailableDataUntilResponseDto
  status: 200
}
    
export type getAvailableDataUntilApiV1ResponseComposite = getAvailableDataUntilApiV1Response200;
    
export type getAvailableDataUntilApiV1Response = getAvailableDataUntilApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetAvailableDataUntilApiV1Url = (workspaceId: unknown,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/channels/metadata/available-data-until`
}

export const getAvailableDataUntilApiV1 = async (workspaceId: unknown, options?: RequestInit): Promise<getAvailableDataUntilApiV1Response> => {
  
  return apiClient<getAvailableDataUntilApiV1Response>(getGetAvailableDataUntilApiV1Url(workspaceId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetAvailableDataUntilApiV1QueryKey = (workspaceId: unknown,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/channels/metadata/available-data-until`] as const;
    }

    
export const getGetAvailableDataUntilApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>, TError = unknown>(workspaceId: unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAvailableDataUntilApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>> = ({ signal }) => getAvailableDataUntilApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAvailableDataUntilApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>>
export type GetAvailableDataUntilApiV1QueryError = unknown


export function useGetAvailableDataUntilApiV1<TData = Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>, TError = unknown>(
 workspaceId: unknown, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>,
          TError,
          Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailableDataUntilApiV1<TData = Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>, TError = unknown>(
 workspaceId: unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>,
          TError,
          Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailableDataUntilApiV1<TData = Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>, TError = unknown>(
 workspaceId: unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAvailableDataUntilApiV1<TData = Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>, TError = unknown>(
 workspaceId: unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAvailableDataUntilApiV1QueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAvailableDataUntilApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>, TError = unknown>(workspaceId: unknown, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAvailableDataUntilApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>> = ({ signal }) => getAvailableDataUntilApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAvailableDataUntilApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>>
export type GetAvailableDataUntilApiV1SuspenseQueryError = unknown


export function useGetAvailableDataUntilApiV1Suspense<TData = Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>, TError = unknown>(
 workspaceId: unknown, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailableDataUntilApiV1Suspense<TData = Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>, TError = unknown>(
 workspaceId: unknown, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailableDataUntilApiV1Suspense<TData = Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>, TError = unknown>(
 workspaceId: unknown, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAvailableDataUntilApiV1Suspense<TData = Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>, TError = unknown>(
 workspaceId: unknown, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailableDataUntilApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAvailableDataUntilApiV1SuspenseQueryOptions(workspaceId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get estimated video metrics
 */
export type getEstimatedVideoMetricsApiV1Response200 = {
  data: GetEstimatedMetricsResponseDto
  status: 200
}
    
export type getEstimatedVideoMetricsApiV1ResponseComposite = getEstimatedVideoMetricsApiV1Response200;
    
export type getEstimatedVideoMetricsApiV1Response = getEstimatedVideoMetricsApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetEstimatedVideoMetricsApiV1Url = (workspaceId: unknown,
    channelId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/channels/${channelId}/estimated-video-metrics`
}

export const getEstimatedVideoMetricsApiV1 = async (workspaceId: unknown,
    channelId: string, options?: RequestInit): Promise<getEstimatedVideoMetricsApiV1Response> => {
  
  return apiClient<getEstimatedVideoMetricsApiV1Response>(getGetEstimatedVideoMetricsApiV1Url(workspaceId,channelId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetEstimatedVideoMetricsApiV1QueryKey = (workspaceId: unknown,
    channelId: string,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/channels/${channelId}/estimated-video-metrics`] as const;
    }

    
export const getGetEstimatedVideoMetricsApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>, TError = unknown>(workspaceId: unknown,
    channelId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEstimatedVideoMetricsApiV1QueryKey(workspaceId,channelId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>> = ({ signal }) => getEstimatedVideoMetricsApiV1(workspaceId,channelId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && channelId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEstimatedVideoMetricsApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>>
export type GetEstimatedVideoMetricsApiV1QueryError = unknown


export function useGetEstimatedVideoMetricsApiV1<TData = Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>, TError = unknown>(
 workspaceId: unknown,
    channelId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEstimatedVideoMetricsApiV1<TData = Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>, TError = unknown>(
 workspaceId: unknown,
    channelId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEstimatedVideoMetricsApiV1<TData = Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>, TError = unknown>(
 workspaceId: unknown,
    channelId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get estimated video metrics
 */

export function useGetEstimatedVideoMetricsApiV1<TData = Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>, TError = unknown>(
 workspaceId: unknown,
    channelId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEstimatedVideoMetricsApiV1QueryOptions(workspaceId,channelId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetEstimatedVideoMetricsApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>, TError = unknown>(workspaceId: unknown,
    channelId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEstimatedVideoMetricsApiV1QueryKey(workspaceId,channelId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>> = ({ signal }) => getEstimatedVideoMetricsApiV1(workspaceId,channelId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEstimatedVideoMetricsApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>>
export type GetEstimatedVideoMetricsApiV1SuspenseQueryError = unknown


export function useGetEstimatedVideoMetricsApiV1Suspense<TData = Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>, TError = unknown>(
 workspaceId: unknown,
    channelId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEstimatedVideoMetricsApiV1Suspense<TData = Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>, TError = unknown>(
 workspaceId: unknown,
    channelId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEstimatedVideoMetricsApiV1Suspense<TData = Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>, TError = unknown>(
 workspaceId: unknown,
    channelId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get estimated video metrics
 */

export function useGetEstimatedVideoMetricsApiV1Suspense<TData = Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>, TError = unknown>(
 workspaceId: unknown,
    channelId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEstimatedVideoMetricsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEstimatedVideoMetricsApiV1SuspenseQueryOptions(workspaceId,channelId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Refresh estimated video metrics
 */
export type refreshEstimatedVideoMetricsApiV1Response200 = {
  data: RefreshEstimatedMetricsResponseDto
  status: 200
}

export type refreshEstimatedVideoMetricsApiV1Response401 = {
  data: void
  status: 401
}
    
export type refreshEstimatedVideoMetricsApiV1ResponseComposite = refreshEstimatedVideoMetricsApiV1Response200 | refreshEstimatedVideoMetricsApiV1Response401;
    
export type refreshEstimatedVideoMetricsApiV1Response = refreshEstimatedVideoMetricsApiV1ResponseComposite & {
  headers: Headers;
}

export const getRefreshEstimatedVideoMetricsApiV1Url = (workspaceId: unknown,
    channelId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/channels/${channelId}/estimated-video-metrics/refresh`
}

export const refreshEstimatedVideoMetricsApiV1 = async (workspaceId: unknown,
    channelId: string, options?: RequestInit): Promise<refreshEstimatedVideoMetricsApiV1Response> => {
  
  return apiClient<refreshEstimatedVideoMetricsApiV1Response>(getRefreshEstimatedVideoMetricsApiV1Url(workspaceId,channelId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getRefreshEstimatedVideoMetricsApiV1MutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshEstimatedVideoMetricsApiV1>>, TError,{workspaceId: unknown;channelId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshEstimatedVideoMetricsApiV1>>, TError,{workspaceId: unknown;channelId: string}, TContext> => {
    
const mutationKey = ['refreshEstimatedVideoMetricsApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshEstimatedVideoMetricsApiV1>>, {workspaceId: unknown;channelId: string}> = (props) => {
          const {workspaceId,channelId} = props ?? {};

          return  refreshEstimatedVideoMetricsApiV1(workspaceId,channelId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RefreshEstimatedVideoMetricsApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof refreshEstimatedVideoMetricsApiV1>>>
    
    export type RefreshEstimatedVideoMetricsApiV1MutationError = void

    /**
 * @summary Refresh estimated video metrics
 */
export const useRefreshEstimatedVideoMetricsApiV1 = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshEstimatedVideoMetricsApiV1>>, TError,{workspaceId: unknown;channelId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof refreshEstimatedVideoMetricsApiV1>>,
        TError,
        {workspaceId: unknown;channelId: string},
        TContext
      > => {

      const mutationOptions = getRefreshEstimatedVideoMetricsApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export type getAvailableAnalyticsApiV1Response200 = {
  data: GetAvailableAnalyticsResponseDto
  status: 200
}
    
export type getAvailableAnalyticsApiV1ResponseComposite = getAvailableAnalyticsApiV1Response200;
    
export type getAvailableAnalyticsApiV1Response = getAvailableAnalyticsApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetAvailableAnalyticsApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/available`
}

export const getAvailableAnalyticsApiV1 = async (workspaceId: string, options?: RequestInit): Promise<getAvailableAnalyticsApiV1Response> => {
  
  return apiClient<getAvailableAnalyticsApiV1Response>(getGetAvailableAnalyticsApiV1Url(workspaceId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetAvailableAnalyticsApiV1QueryKey = (workspaceId: string,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/available`] as const;
    }

    
export const getGetAvailableAnalyticsApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAvailableAnalyticsApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>> = ({ signal }) => getAvailableAnalyticsApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAvailableAnalyticsApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>>
export type GetAvailableAnalyticsApiV1QueryError = unknown


export function useGetAvailableAnalyticsApiV1<TData = Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailableAnalyticsApiV1<TData = Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailableAnalyticsApiV1<TData = Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAvailableAnalyticsApiV1<TData = Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAvailableAnalyticsApiV1QueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAvailableAnalyticsApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAvailableAnalyticsApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>> = ({ signal }) => getAvailableAnalyticsApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAvailableAnalyticsApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>>
export type GetAvailableAnalyticsApiV1SuspenseQueryError = unknown


export function useGetAvailableAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailableAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailableAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAvailableAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailableAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAvailableAnalyticsApiV1SuspenseQueryOptions(workspaceId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type getOverviewAnalyticsApiV1Response200 = {
  data: GetOverviewAnalyticsResponseDto
  status: 200
}
    
export type getOverviewAnalyticsApiV1ResponseComposite = getOverviewAnalyticsApiV1Response200;
    
export type getOverviewAnalyticsApiV1Response = getOverviewAnalyticsApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetOverviewAnalyticsApiV1Url = (workspaceId: string,
    params?: GetOverviewAnalyticsApiV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/overview?${stringifiedParams}` : `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/overview`
}

export const getOverviewAnalyticsApiV1 = async (workspaceId: string,
    params?: GetOverviewAnalyticsApiV1Params, options?: RequestInit): Promise<getOverviewAnalyticsApiV1Response> => {
  
  return apiClient<getOverviewAnalyticsApiV1Response>(getGetOverviewAnalyticsApiV1Url(workspaceId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetOverviewAnalyticsApiV1QueryKey = (workspaceId: string,
    params?: GetOverviewAnalyticsApiV1Params,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/overview`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOverviewAnalyticsApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>, TError = unknown>(workspaceId: string,
    params?: GetOverviewAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOverviewAnalyticsApiV1QueryKey(workspaceId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>> = ({ signal }) => getOverviewAnalyticsApiV1(workspaceId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOverviewAnalyticsApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>>
export type GetOverviewAnalyticsApiV1QueryError = unknown


export function useGetOverviewAnalyticsApiV1<TData = Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params: undefined |  GetOverviewAnalyticsApiV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverviewAnalyticsApiV1<TData = Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetOverviewAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverviewAnalyticsApiV1<TData = Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetOverviewAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOverviewAnalyticsApiV1<TData = Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetOverviewAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOverviewAnalyticsApiV1QueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetOverviewAnalyticsApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>, TError = unknown>(workspaceId: string,
    params?: GetOverviewAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOverviewAnalyticsApiV1QueryKey(workspaceId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>> = ({ signal }) => getOverviewAnalyticsApiV1(workspaceId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOverviewAnalyticsApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>>
export type GetOverviewAnalyticsApiV1SuspenseQueryError = unknown


export function useGetOverviewAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params: undefined |  GetOverviewAnalyticsApiV1Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverviewAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetOverviewAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverviewAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetOverviewAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOverviewAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetOverviewAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOverviewAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOverviewAnalyticsApiV1SuspenseQueryOptions(workspaceId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type getPlatformAnalyticsApiV1Response200 = {
  data: GetPlatformAnalyticsResponseDto
  status: 200
}
    
export type getPlatformAnalyticsApiV1ResponseComposite = getPlatformAnalyticsApiV1Response200;
    
export type getPlatformAnalyticsApiV1Response = getPlatformAnalyticsApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetPlatformAnalyticsApiV1Url = (workspaceId: string,
    params?: GetPlatformAnalyticsApiV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/platforms?${stringifiedParams}` : `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/platforms`
}

export const getPlatformAnalyticsApiV1 = async (workspaceId: string,
    params?: GetPlatformAnalyticsApiV1Params, options?: RequestInit): Promise<getPlatformAnalyticsApiV1Response> => {
  
  return apiClient<getPlatformAnalyticsApiV1Response>(getGetPlatformAnalyticsApiV1Url(workspaceId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetPlatformAnalyticsApiV1QueryKey = (workspaceId: string,
    params?: GetPlatformAnalyticsApiV1Params,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/platforms`, ...(params ? [params]: [])] as const;
    }

    
export const getGetPlatformAnalyticsApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>, TError = unknown>(workspaceId: string,
    params?: GetPlatformAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformAnalyticsApiV1QueryKey(workspaceId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>> = ({ signal }) => getPlatformAnalyticsApiV1(workspaceId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlatformAnalyticsApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>>
export type GetPlatformAnalyticsApiV1QueryError = unknown


export function useGetPlatformAnalyticsApiV1<TData = Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params: undefined |  GetPlatformAnalyticsApiV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformAnalyticsApiV1<TData = Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetPlatformAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformAnalyticsApiV1<TData = Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetPlatformAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPlatformAnalyticsApiV1<TData = Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetPlatformAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformAnalyticsApiV1QueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetPlatformAnalyticsApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>, TError = unknown>(workspaceId: string,
    params?: GetPlatformAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformAnalyticsApiV1QueryKey(workspaceId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>> = ({ signal }) => getPlatformAnalyticsApiV1(workspaceId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlatformAnalyticsApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>>
export type GetPlatformAnalyticsApiV1SuspenseQueryError = unknown


export function useGetPlatformAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params: undefined |  GetPlatformAnalyticsApiV1Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetPlatformAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetPlatformAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPlatformAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetPlatformAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlatformAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformAnalyticsApiV1SuspenseQueryOptions(workspaceId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type getTrackAnalyticsApiV1Response200 = {
  data: GetTrackAnalyticsResponseDto
  status: 200
}
    
export type getTrackAnalyticsApiV1ResponseComposite = getTrackAnalyticsApiV1Response200;
    
export type getTrackAnalyticsApiV1Response = getTrackAnalyticsApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetTrackAnalyticsApiV1Url = (workspaceId: string,
    params?: GetTrackAnalyticsApiV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/tracks?${stringifiedParams}` : `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/tracks`
}

export const getTrackAnalyticsApiV1 = async (workspaceId: string,
    params?: GetTrackAnalyticsApiV1Params, options?: RequestInit): Promise<getTrackAnalyticsApiV1Response> => {
  
  return apiClient<getTrackAnalyticsApiV1Response>(getGetTrackAnalyticsApiV1Url(workspaceId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetTrackAnalyticsApiV1QueryKey = (workspaceId: string,
    params?: GetTrackAnalyticsApiV1Params,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/tracks`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTrackAnalyticsApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>, TError = unknown>(workspaceId: string,
    params?: GetTrackAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrackAnalyticsApiV1QueryKey(workspaceId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>> = ({ signal }) => getTrackAnalyticsApiV1(workspaceId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTrackAnalyticsApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>>
export type GetTrackAnalyticsApiV1QueryError = unknown


export function useGetTrackAnalyticsApiV1<TData = Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params: undefined |  GetTrackAnalyticsApiV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackAnalyticsApiV1<TData = Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetTrackAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackAnalyticsApiV1<TData = Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetTrackAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTrackAnalyticsApiV1<TData = Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetTrackAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrackAnalyticsApiV1QueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetTrackAnalyticsApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>, TError = unknown>(workspaceId: string,
    params?: GetTrackAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrackAnalyticsApiV1QueryKey(workspaceId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>> = ({ signal }) => getTrackAnalyticsApiV1(workspaceId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTrackAnalyticsApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>>
export type GetTrackAnalyticsApiV1SuspenseQueryError = unknown


export function useGetTrackAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params: undefined |  GetTrackAnalyticsApiV1Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetTrackAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetTrackAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTrackAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetTrackAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrackAnalyticsApiV1SuspenseQueryOptions(workspaceId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type getAlbumAnalyticsApiV1Response200 = {
  data: GetAlbumAnalyticsResponseDto
  status: 200
}
    
export type getAlbumAnalyticsApiV1ResponseComposite = getAlbumAnalyticsApiV1Response200;
    
export type getAlbumAnalyticsApiV1Response = getAlbumAnalyticsApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetAlbumAnalyticsApiV1Url = (workspaceId: string,
    params?: GetAlbumAnalyticsApiV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/albums?${stringifiedParams}` : `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/albums`
}

export const getAlbumAnalyticsApiV1 = async (workspaceId: string,
    params?: GetAlbumAnalyticsApiV1Params, options?: RequestInit): Promise<getAlbumAnalyticsApiV1Response> => {
  
  return apiClient<getAlbumAnalyticsApiV1Response>(getGetAlbumAnalyticsApiV1Url(workspaceId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetAlbumAnalyticsApiV1QueryKey = (workspaceId: string,
    params?: GetAlbumAnalyticsApiV1Params,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/albums`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAlbumAnalyticsApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>, TError = unknown>(workspaceId: string,
    params?: GetAlbumAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAlbumAnalyticsApiV1QueryKey(workspaceId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>> = ({ signal }) => getAlbumAnalyticsApiV1(workspaceId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAlbumAnalyticsApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>>
export type GetAlbumAnalyticsApiV1QueryError = unknown


export function useGetAlbumAnalyticsApiV1<TData = Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params: undefined |  GetAlbumAnalyticsApiV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAlbumAnalyticsApiV1<TData = Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetAlbumAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAlbumAnalyticsApiV1<TData = Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetAlbumAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAlbumAnalyticsApiV1<TData = Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetAlbumAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAlbumAnalyticsApiV1QueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAlbumAnalyticsApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>, TError = unknown>(workspaceId: string,
    params?: GetAlbumAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAlbumAnalyticsApiV1QueryKey(workspaceId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>> = ({ signal }) => getAlbumAnalyticsApiV1(workspaceId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAlbumAnalyticsApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>>
export type GetAlbumAnalyticsApiV1SuspenseQueryError = unknown


export function useGetAlbumAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params: undefined |  GetAlbumAnalyticsApiV1Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAlbumAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetAlbumAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAlbumAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetAlbumAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAlbumAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetAlbumAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAlbumAnalyticsApiV1SuspenseQueryOptions(workspaceId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type getArtistAnalyticsApiV1Response200 = {
  data: GetArtistAnalyticsResponseDto
  status: 200
}
    
export type getArtistAnalyticsApiV1ResponseComposite = getArtistAnalyticsApiV1Response200;
    
export type getArtistAnalyticsApiV1Response = getArtistAnalyticsApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetArtistAnalyticsApiV1Url = (workspaceId: string,
    params?: GetArtistAnalyticsApiV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/artists?${stringifiedParams}` : `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/artists`
}

export const getArtistAnalyticsApiV1 = async (workspaceId: string,
    params?: GetArtistAnalyticsApiV1Params, options?: RequestInit): Promise<getArtistAnalyticsApiV1Response> => {
  
  return apiClient<getArtistAnalyticsApiV1Response>(getGetArtistAnalyticsApiV1Url(workspaceId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetArtistAnalyticsApiV1QueryKey = (workspaceId: string,
    params?: GetArtistAnalyticsApiV1Params,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/artists`, ...(params ? [params]: [])] as const;
    }

    
export const getGetArtistAnalyticsApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>, TError = unknown>(workspaceId: string,
    params?: GetArtistAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetArtistAnalyticsApiV1QueryKey(workspaceId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>> = ({ signal }) => getArtistAnalyticsApiV1(workspaceId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetArtistAnalyticsApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>>
export type GetArtistAnalyticsApiV1QueryError = unknown


export function useGetArtistAnalyticsApiV1<TData = Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params: undefined |  GetArtistAnalyticsApiV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArtistAnalyticsApiV1<TData = Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetArtistAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArtistAnalyticsApiV1<TData = Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetArtistAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetArtistAnalyticsApiV1<TData = Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetArtistAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetArtistAnalyticsApiV1QueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetArtistAnalyticsApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>, TError = unknown>(workspaceId: string,
    params?: GetArtistAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetArtistAnalyticsApiV1QueryKey(workspaceId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>> = ({ signal }) => getArtistAnalyticsApiV1(workspaceId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetArtistAnalyticsApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>>
export type GetArtistAnalyticsApiV1SuspenseQueryError = unknown


export function useGetArtistAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params: undefined |  GetArtistAnalyticsApiV1Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArtistAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetArtistAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArtistAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetArtistAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetArtistAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetArtistAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getArtistAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetArtistAnalyticsApiV1SuspenseQueryOptions(workspaceId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type getCountryAnalyticsApiV1Response200 = {
  data: GetCountryAnalyticsResponseDto
  status: 200
}
    
export type getCountryAnalyticsApiV1ResponseComposite = getCountryAnalyticsApiV1Response200;
    
export type getCountryAnalyticsApiV1Response = getCountryAnalyticsApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetCountryAnalyticsApiV1Url = (workspaceId: string,
    params?: GetCountryAnalyticsApiV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/countries?${stringifiedParams}` : `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/countries`
}

export const getCountryAnalyticsApiV1 = async (workspaceId: string,
    params?: GetCountryAnalyticsApiV1Params, options?: RequestInit): Promise<getCountryAnalyticsApiV1Response> => {
  
  return apiClient<getCountryAnalyticsApiV1Response>(getGetCountryAnalyticsApiV1Url(workspaceId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetCountryAnalyticsApiV1QueryKey = (workspaceId: string,
    params?: GetCountryAnalyticsApiV1Params,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/countries`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCountryAnalyticsApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>, TError = unknown>(workspaceId: string,
    params?: GetCountryAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCountryAnalyticsApiV1QueryKey(workspaceId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>> = ({ signal }) => getCountryAnalyticsApiV1(workspaceId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCountryAnalyticsApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>>
export type GetCountryAnalyticsApiV1QueryError = unknown


export function useGetCountryAnalyticsApiV1<TData = Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params: undefined |  GetCountryAnalyticsApiV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCountryAnalyticsApiV1<TData = Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetCountryAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCountryAnalyticsApiV1<TData = Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetCountryAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCountryAnalyticsApiV1<TData = Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetCountryAnalyticsApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCountryAnalyticsApiV1QueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCountryAnalyticsApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>, TError = unknown>(workspaceId: string,
    params?: GetCountryAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCountryAnalyticsApiV1QueryKey(workspaceId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>> = ({ signal }) => getCountryAnalyticsApiV1(workspaceId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCountryAnalyticsApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>>
export type GetCountryAnalyticsApiV1SuspenseQueryError = unknown


export function useGetCountryAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params: undefined |  GetCountryAnalyticsApiV1Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCountryAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetCountryAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCountryAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetCountryAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCountryAnalyticsApiV1Suspense<TData = Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>, TError = unknown>(
 workspaceId: string,
    params?: GetCountryAnalyticsApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCountryAnalyticsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCountryAnalyticsApiV1SuspenseQueryOptions(workspaceId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type getTrackDetailApiV1Response200 = {
  data: GetTrackDetailResponseDto
  status: 200
}
    
export type getTrackDetailApiV1ResponseComposite = getTrackDetailApiV1Response200;
    
export type getTrackDetailApiV1Response = getTrackDetailApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetTrackDetailApiV1Url = (workspaceId: string,
    code: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/tracks/${code}`
}

export const getTrackDetailApiV1 = async (workspaceId: string,
    code: string, options?: RequestInit): Promise<getTrackDetailApiV1Response> => {
  
  return apiClient<getTrackDetailApiV1Response>(getGetTrackDetailApiV1Url(workspaceId,code),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetTrackDetailApiV1QueryKey = (workspaceId: string,
    code: string,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/tracks/${code}`] as const;
    }

    
export const getGetTrackDetailApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getTrackDetailApiV1>>, TError = unknown>(workspaceId: string,
    code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackDetailApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrackDetailApiV1QueryKey(workspaceId,code);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrackDetailApiV1>>> = ({ signal }) => getTrackDetailApiV1(workspaceId,code, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && code), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrackDetailApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTrackDetailApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getTrackDetailApiV1>>>
export type GetTrackDetailApiV1QueryError = unknown


export function useGetTrackDetailApiV1<TData = Awaited<ReturnType<typeof getTrackDetailApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackDetailApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrackDetailApiV1>>,
          TError,
          Awaited<ReturnType<typeof getTrackDetailApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackDetailApiV1<TData = Awaited<ReturnType<typeof getTrackDetailApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackDetailApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrackDetailApiV1>>,
          TError,
          Awaited<ReturnType<typeof getTrackDetailApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackDetailApiV1<TData = Awaited<ReturnType<typeof getTrackDetailApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackDetailApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTrackDetailApiV1<TData = Awaited<ReturnType<typeof getTrackDetailApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackDetailApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrackDetailApiV1QueryOptions(workspaceId,code,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetTrackDetailApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTrackDetailApiV1>>, TError = unknown>(workspaceId: string,
    code: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackDetailApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrackDetailApiV1QueryKey(workspaceId,code);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrackDetailApiV1>>> = ({ signal }) => getTrackDetailApiV1(workspaceId,code, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackDetailApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTrackDetailApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTrackDetailApiV1>>>
export type GetTrackDetailApiV1SuspenseQueryError = unknown


export function useGetTrackDetailApiV1Suspense<TData = Awaited<ReturnType<typeof getTrackDetailApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackDetailApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackDetailApiV1Suspense<TData = Awaited<ReturnType<typeof getTrackDetailApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackDetailApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackDetailApiV1Suspense<TData = Awaited<ReturnType<typeof getTrackDetailApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackDetailApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTrackDetailApiV1Suspense<TData = Awaited<ReturnType<typeof getTrackDetailApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackDetailApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrackDetailApiV1SuspenseQueryOptions(workspaceId,code,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type getAlbumDetailApiV1Response200 = {
  data: GetAlbumDetailResponseDto
  status: 200
}
    
export type getAlbumDetailApiV1ResponseComposite = getAlbumDetailApiV1Response200;
    
export type getAlbumDetailApiV1Response = getAlbumDetailApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetAlbumDetailApiV1Url = (workspaceId: string,
    code: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/albums/${code}`
}

export const getAlbumDetailApiV1 = async (workspaceId: string,
    code: string, options?: RequestInit): Promise<getAlbumDetailApiV1Response> => {
  
  return apiClient<getAlbumDetailApiV1Response>(getGetAlbumDetailApiV1Url(workspaceId,code),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetAlbumDetailApiV1QueryKey = (workspaceId: string,
    code: string,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/albums/${code}`] as const;
    }

    
export const getGetAlbumDetailApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getAlbumDetailApiV1>>, TError = unknown>(workspaceId: string,
    code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAlbumDetailApiV1QueryKey(workspaceId,code);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAlbumDetailApiV1>>> = ({ signal }) => getAlbumDetailApiV1(workspaceId,code, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && code), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAlbumDetailApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getAlbumDetailApiV1>>>
export type GetAlbumDetailApiV1QueryError = unknown


export function useGetAlbumDetailApiV1<TData = Awaited<ReturnType<typeof getAlbumDetailApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAlbumDetailApiV1>>,
          TError,
          Awaited<ReturnType<typeof getAlbumDetailApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAlbumDetailApiV1<TData = Awaited<ReturnType<typeof getAlbumDetailApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAlbumDetailApiV1>>,
          TError,
          Awaited<ReturnType<typeof getAlbumDetailApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAlbumDetailApiV1<TData = Awaited<ReturnType<typeof getAlbumDetailApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAlbumDetailApiV1<TData = Awaited<ReturnType<typeof getAlbumDetailApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAlbumDetailApiV1QueryOptions(workspaceId,code,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAlbumDetailApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAlbumDetailApiV1>>, TError = unknown>(workspaceId: string,
    code: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAlbumDetailApiV1QueryKey(workspaceId,code);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAlbumDetailApiV1>>> = ({ signal }) => getAlbumDetailApiV1(workspaceId,code, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAlbumDetailApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAlbumDetailApiV1>>>
export type GetAlbumDetailApiV1SuspenseQueryError = unknown


export function useGetAlbumDetailApiV1Suspense<TData = Awaited<ReturnType<typeof getAlbumDetailApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAlbumDetailApiV1Suspense<TData = Awaited<ReturnType<typeof getAlbumDetailApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAlbumDetailApiV1Suspense<TData = Awaited<ReturnType<typeof getAlbumDetailApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAlbumDetailApiV1Suspense<TData = Awaited<ReturnType<typeof getAlbumDetailApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAlbumDetailApiV1SuspenseQueryOptions(workspaceId,code,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type getTrackDetailOverviewApiV1Response200 = {
  data: GetTrackDetailAnalyticsResponseDto
  status: 200
}
    
export type getTrackDetailOverviewApiV1ResponseComposite = getTrackDetailOverviewApiV1Response200;
    
export type getTrackDetailOverviewApiV1Response = getTrackDetailOverviewApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetTrackDetailOverviewApiV1Url = (workspaceId: string,
    code: string,
    params?: GetTrackDetailOverviewApiV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/tracks/${code}/overview?${stringifiedParams}` : `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/tracks/${code}/overview`
}

export const getTrackDetailOverviewApiV1 = async (workspaceId: string,
    code: string,
    params?: GetTrackDetailOverviewApiV1Params, options?: RequestInit): Promise<getTrackDetailOverviewApiV1Response> => {
  
  return apiClient<getTrackDetailOverviewApiV1Response>(getGetTrackDetailOverviewApiV1Url(workspaceId,code,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetTrackDetailOverviewApiV1QueryKey = (workspaceId: string,
    code: string,
    params?: GetTrackDetailOverviewApiV1Params,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/tracks/${code}/overview`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTrackDetailOverviewApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>, TError = unknown>(workspaceId: string,
    code: string,
    params?: GetTrackDetailOverviewApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrackDetailOverviewApiV1QueryKey(workspaceId,code,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>> = ({ signal }) => getTrackDetailOverviewApiV1(workspaceId,code,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && code), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTrackDetailOverviewApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>>
export type GetTrackDetailOverviewApiV1QueryError = unknown


export function useGetTrackDetailOverviewApiV1<TData = Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params: undefined |  GetTrackDetailOverviewApiV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>,
          TError,
          Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackDetailOverviewApiV1<TData = Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetTrackDetailOverviewApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>,
          TError,
          Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackDetailOverviewApiV1<TData = Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetTrackDetailOverviewApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTrackDetailOverviewApiV1<TData = Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetTrackDetailOverviewApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrackDetailOverviewApiV1QueryOptions(workspaceId,code,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetTrackDetailOverviewApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>, TError = unknown>(workspaceId: string,
    code: string,
    params?: GetTrackDetailOverviewApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrackDetailOverviewApiV1QueryKey(workspaceId,code,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>> = ({ signal }) => getTrackDetailOverviewApiV1(workspaceId,code,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTrackDetailOverviewApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>>
export type GetTrackDetailOverviewApiV1SuspenseQueryError = unknown


export function useGetTrackDetailOverviewApiV1Suspense<TData = Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params: undefined |  GetTrackDetailOverviewApiV1Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackDetailOverviewApiV1Suspense<TData = Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetTrackDetailOverviewApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackDetailOverviewApiV1Suspense<TData = Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetTrackDetailOverviewApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTrackDetailOverviewApiV1Suspense<TData = Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetTrackDetailOverviewApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackDetailOverviewApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrackDetailOverviewApiV1SuspenseQueryOptions(workspaceId,code,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type getAlbumDetailOverviewApiV1Response200 = {
  data: GetAlbumDetailAnalyticsResponseDto
  status: 200
}
    
export type getAlbumDetailOverviewApiV1ResponseComposite = getAlbumDetailOverviewApiV1Response200;
    
export type getAlbumDetailOverviewApiV1Response = getAlbumDetailOverviewApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetAlbumDetailOverviewApiV1Url = (workspaceId: string,
    code: string,
    params?: GetAlbumDetailOverviewApiV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/albums/${code}/overview?${stringifiedParams}` : `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/albums/${code}/overview`
}

export const getAlbumDetailOverviewApiV1 = async (workspaceId: string,
    code: string,
    params?: GetAlbumDetailOverviewApiV1Params, options?: RequestInit): Promise<getAlbumDetailOverviewApiV1Response> => {
  
  return apiClient<getAlbumDetailOverviewApiV1Response>(getGetAlbumDetailOverviewApiV1Url(workspaceId,code,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetAlbumDetailOverviewApiV1QueryKey = (workspaceId: string,
    code: string,
    params?: GetAlbumDetailOverviewApiV1Params,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/albums/${code}/overview`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAlbumDetailOverviewApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>, TError = unknown>(workspaceId: string,
    code: string,
    params?: GetAlbumDetailOverviewApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAlbumDetailOverviewApiV1QueryKey(workspaceId,code,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>> = ({ signal }) => getAlbumDetailOverviewApiV1(workspaceId,code,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && code), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAlbumDetailOverviewApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>>
export type GetAlbumDetailOverviewApiV1QueryError = unknown


export function useGetAlbumDetailOverviewApiV1<TData = Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params: undefined |  GetAlbumDetailOverviewApiV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>,
          TError,
          Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAlbumDetailOverviewApiV1<TData = Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetAlbumDetailOverviewApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>,
          TError,
          Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAlbumDetailOverviewApiV1<TData = Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetAlbumDetailOverviewApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAlbumDetailOverviewApiV1<TData = Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetAlbumDetailOverviewApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAlbumDetailOverviewApiV1QueryOptions(workspaceId,code,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAlbumDetailOverviewApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>, TError = unknown>(workspaceId: string,
    code: string,
    params?: GetAlbumDetailOverviewApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAlbumDetailOverviewApiV1QueryKey(workspaceId,code,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>> = ({ signal }) => getAlbumDetailOverviewApiV1(workspaceId,code,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAlbumDetailOverviewApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>>
export type GetAlbumDetailOverviewApiV1SuspenseQueryError = unknown


export function useGetAlbumDetailOverviewApiV1Suspense<TData = Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params: undefined |  GetAlbumDetailOverviewApiV1Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAlbumDetailOverviewApiV1Suspense<TData = Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetAlbumDetailOverviewApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAlbumDetailOverviewApiV1Suspense<TData = Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetAlbumDetailOverviewApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAlbumDetailOverviewApiV1Suspense<TData = Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetAlbumDetailOverviewApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailOverviewApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAlbumDetailOverviewApiV1SuspenseQueryOptions(workspaceId,code,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type getTrackDetailPlatformApiV1Response200 = {
  data: GetTrackDetailPlatformResponseDto
  status: 200
}
    
export type getTrackDetailPlatformApiV1ResponseComposite = getTrackDetailPlatformApiV1Response200;
    
export type getTrackDetailPlatformApiV1Response = getTrackDetailPlatformApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetTrackDetailPlatformApiV1Url = (workspaceId: string,
    code: string,
    params?: GetTrackDetailPlatformApiV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/tracks/${code}/platform?${stringifiedParams}` : `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/tracks/${code}/platform`
}

export const getTrackDetailPlatformApiV1 = async (workspaceId: string,
    code: string,
    params?: GetTrackDetailPlatformApiV1Params, options?: RequestInit): Promise<getTrackDetailPlatformApiV1Response> => {
  
  return apiClient<getTrackDetailPlatformApiV1Response>(getGetTrackDetailPlatformApiV1Url(workspaceId,code,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetTrackDetailPlatformApiV1QueryKey = (workspaceId: string,
    code: string,
    params?: GetTrackDetailPlatformApiV1Params,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/tracks/${code}/platform`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTrackDetailPlatformApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>, TError = unknown>(workspaceId: string,
    code: string,
    params?: GetTrackDetailPlatformApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrackDetailPlatformApiV1QueryKey(workspaceId,code,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>> = ({ signal }) => getTrackDetailPlatformApiV1(workspaceId,code,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && code), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTrackDetailPlatformApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>>
export type GetTrackDetailPlatformApiV1QueryError = unknown


export function useGetTrackDetailPlatformApiV1<TData = Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params: undefined |  GetTrackDetailPlatformApiV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>,
          TError,
          Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackDetailPlatformApiV1<TData = Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetTrackDetailPlatformApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>,
          TError,
          Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackDetailPlatformApiV1<TData = Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetTrackDetailPlatformApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTrackDetailPlatformApiV1<TData = Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetTrackDetailPlatformApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrackDetailPlatformApiV1QueryOptions(workspaceId,code,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetTrackDetailPlatformApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>, TError = unknown>(workspaceId: string,
    code: string,
    params?: GetTrackDetailPlatformApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrackDetailPlatformApiV1QueryKey(workspaceId,code,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>> = ({ signal }) => getTrackDetailPlatformApiV1(workspaceId,code,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTrackDetailPlatformApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>>
export type GetTrackDetailPlatformApiV1SuspenseQueryError = unknown


export function useGetTrackDetailPlatformApiV1Suspense<TData = Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params: undefined |  GetTrackDetailPlatformApiV1Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackDetailPlatformApiV1Suspense<TData = Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetTrackDetailPlatformApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackDetailPlatformApiV1Suspense<TData = Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetTrackDetailPlatformApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTrackDetailPlatformApiV1Suspense<TData = Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetTrackDetailPlatformApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackDetailPlatformApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrackDetailPlatformApiV1SuspenseQueryOptions(workspaceId,code,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type getTrackDetailCountryApiV1Response200 = {
  data: GetTrackDetailCountryResponseDto
  status: 200
}
    
export type getTrackDetailCountryApiV1ResponseComposite = getTrackDetailCountryApiV1Response200;
    
export type getTrackDetailCountryApiV1Response = getTrackDetailCountryApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetTrackDetailCountryApiV1Url = (workspaceId: string,
    code: string,
    params?: GetTrackDetailCountryApiV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/tracks/${code}/country?${stringifiedParams}` : `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/tracks/${code}/country`
}

export const getTrackDetailCountryApiV1 = async (workspaceId: string,
    code: string,
    params?: GetTrackDetailCountryApiV1Params, options?: RequestInit): Promise<getTrackDetailCountryApiV1Response> => {
  
  return apiClient<getTrackDetailCountryApiV1Response>(getGetTrackDetailCountryApiV1Url(workspaceId,code,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetTrackDetailCountryApiV1QueryKey = (workspaceId: string,
    code: string,
    params?: GetTrackDetailCountryApiV1Params,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/tracks/${code}/country`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTrackDetailCountryApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>, TError = unknown>(workspaceId: string,
    code: string,
    params?: GetTrackDetailCountryApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrackDetailCountryApiV1QueryKey(workspaceId,code,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>> = ({ signal }) => getTrackDetailCountryApiV1(workspaceId,code,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && code), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTrackDetailCountryApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>>
export type GetTrackDetailCountryApiV1QueryError = unknown


export function useGetTrackDetailCountryApiV1<TData = Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params: undefined |  GetTrackDetailCountryApiV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>,
          TError,
          Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackDetailCountryApiV1<TData = Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetTrackDetailCountryApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>,
          TError,
          Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackDetailCountryApiV1<TData = Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetTrackDetailCountryApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTrackDetailCountryApiV1<TData = Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetTrackDetailCountryApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrackDetailCountryApiV1QueryOptions(workspaceId,code,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetTrackDetailCountryApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>, TError = unknown>(workspaceId: string,
    code: string,
    params?: GetTrackDetailCountryApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrackDetailCountryApiV1QueryKey(workspaceId,code,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>> = ({ signal }) => getTrackDetailCountryApiV1(workspaceId,code,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTrackDetailCountryApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>>
export type GetTrackDetailCountryApiV1SuspenseQueryError = unknown


export function useGetTrackDetailCountryApiV1Suspense<TData = Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params: undefined |  GetTrackDetailCountryApiV1Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackDetailCountryApiV1Suspense<TData = Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetTrackDetailCountryApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackDetailCountryApiV1Suspense<TData = Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetTrackDetailCountryApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTrackDetailCountryApiV1Suspense<TData = Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetTrackDetailCountryApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrackDetailCountryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrackDetailCountryApiV1SuspenseQueryOptions(workspaceId,code,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type getAlbumDetailPlatformApiV1Response200 = {
  data: GetAlbumDetailPlatformResponseDto
  status: 200
}
    
export type getAlbumDetailPlatformApiV1ResponseComposite = getAlbumDetailPlatformApiV1Response200;
    
export type getAlbumDetailPlatformApiV1Response = getAlbumDetailPlatformApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetAlbumDetailPlatformApiV1Url = (workspaceId: string,
    code: string,
    params?: GetAlbumDetailPlatformApiV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/albums/${code}/platform?${stringifiedParams}` : `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/albums/${code}/platform`
}

export const getAlbumDetailPlatformApiV1 = async (workspaceId: string,
    code: string,
    params?: GetAlbumDetailPlatformApiV1Params, options?: RequestInit): Promise<getAlbumDetailPlatformApiV1Response> => {
  
  return apiClient<getAlbumDetailPlatformApiV1Response>(getGetAlbumDetailPlatformApiV1Url(workspaceId,code,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetAlbumDetailPlatformApiV1QueryKey = (workspaceId: string,
    code: string,
    params?: GetAlbumDetailPlatformApiV1Params,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/albums/${code}/platform`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAlbumDetailPlatformApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>, TError = unknown>(workspaceId: string,
    code: string,
    params?: GetAlbumDetailPlatformApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAlbumDetailPlatformApiV1QueryKey(workspaceId,code,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>> = ({ signal }) => getAlbumDetailPlatformApiV1(workspaceId,code,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && code), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAlbumDetailPlatformApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>>
export type GetAlbumDetailPlatformApiV1QueryError = unknown


export function useGetAlbumDetailPlatformApiV1<TData = Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params: undefined |  GetAlbumDetailPlatformApiV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>,
          TError,
          Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAlbumDetailPlatformApiV1<TData = Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetAlbumDetailPlatformApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>,
          TError,
          Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAlbumDetailPlatformApiV1<TData = Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetAlbumDetailPlatformApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAlbumDetailPlatformApiV1<TData = Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetAlbumDetailPlatformApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAlbumDetailPlatformApiV1QueryOptions(workspaceId,code,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAlbumDetailPlatformApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>, TError = unknown>(workspaceId: string,
    code: string,
    params?: GetAlbumDetailPlatformApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAlbumDetailPlatformApiV1QueryKey(workspaceId,code,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>> = ({ signal }) => getAlbumDetailPlatformApiV1(workspaceId,code,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAlbumDetailPlatformApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>>
export type GetAlbumDetailPlatformApiV1SuspenseQueryError = unknown


export function useGetAlbumDetailPlatformApiV1Suspense<TData = Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params: undefined |  GetAlbumDetailPlatformApiV1Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAlbumDetailPlatformApiV1Suspense<TData = Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetAlbumDetailPlatformApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAlbumDetailPlatformApiV1Suspense<TData = Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetAlbumDetailPlatformApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAlbumDetailPlatformApiV1Suspense<TData = Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetAlbumDetailPlatformApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailPlatformApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAlbumDetailPlatformApiV1SuspenseQueryOptions(workspaceId,code,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type getAlbumDetailCountryApiV1Response200 = {
  data: GetAlbumDetailCountryResponseDto
  status: 200
}
    
export type getAlbumDetailCountryApiV1ResponseComposite = getAlbumDetailCountryApiV1Response200;
    
export type getAlbumDetailCountryApiV1Response = getAlbumDetailCountryApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetAlbumDetailCountryApiV1Url = (workspaceId: string,
    code: string,
    params?: GetAlbumDetailCountryApiV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/albums/${code}/country?${stringifiedParams}` : `http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/albums/${code}/country`
}

export const getAlbumDetailCountryApiV1 = async (workspaceId: string,
    code: string,
    params?: GetAlbumDetailCountryApiV1Params, options?: RequestInit): Promise<getAlbumDetailCountryApiV1Response> => {
  
  return apiClient<getAlbumDetailCountryApiV1Response>(getGetAlbumDetailCountryApiV1Url(workspaceId,code,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetAlbumDetailCountryApiV1QueryKey = (workspaceId: string,
    code: string,
    params?: GetAlbumDetailCountryApiV1Params,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/analytics/custom-music/albums/${code}/country`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAlbumDetailCountryApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>, TError = unknown>(workspaceId: string,
    code: string,
    params?: GetAlbumDetailCountryApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAlbumDetailCountryApiV1QueryKey(workspaceId,code,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>> = ({ signal }) => getAlbumDetailCountryApiV1(workspaceId,code,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && code), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAlbumDetailCountryApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>>
export type GetAlbumDetailCountryApiV1QueryError = unknown


export function useGetAlbumDetailCountryApiV1<TData = Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params: undefined |  GetAlbumDetailCountryApiV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>,
          TError,
          Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAlbumDetailCountryApiV1<TData = Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetAlbumDetailCountryApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>,
          TError,
          Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAlbumDetailCountryApiV1<TData = Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetAlbumDetailCountryApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAlbumDetailCountryApiV1<TData = Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetAlbumDetailCountryApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAlbumDetailCountryApiV1QueryOptions(workspaceId,code,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAlbumDetailCountryApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>, TError = unknown>(workspaceId: string,
    code: string,
    params?: GetAlbumDetailCountryApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAlbumDetailCountryApiV1QueryKey(workspaceId,code,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>> = ({ signal }) => getAlbumDetailCountryApiV1(workspaceId,code,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAlbumDetailCountryApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>>
export type GetAlbumDetailCountryApiV1SuspenseQueryError = unknown


export function useGetAlbumDetailCountryApiV1Suspense<TData = Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params: undefined |  GetAlbumDetailCountryApiV1Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAlbumDetailCountryApiV1Suspense<TData = Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetAlbumDetailCountryApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAlbumDetailCountryApiV1Suspense<TData = Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetAlbumDetailCountryApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAlbumDetailCountryApiV1Suspense<TData = Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>, TError = unknown>(
 workspaceId: string,
    code: string,
    params?: GetAlbumDetailCountryApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAlbumDetailCountryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAlbumDetailCountryApiV1SuspenseQueryOptions(workspaceId,code,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get all invitations for the current user
 */
export type getInvitationsApiV1Response200 = {
  data: GetWorkspaceInvitaitonsResponseDto
  status: 200
}
    
export type getInvitationsApiV1ResponseComposite = getInvitationsApiV1Response200;
    
export type getInvitationsApiV1Response = getInvitationsApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetInvitationsApiV1Url = () => {


  

  return `http://localhost:8888/api/v1/workspaces/invitations`
}

export const getInvitationsApiV1 = async ( options?: RequestInit): Promise<getInvitationsApiV1Response> => {
  
  return apiClient<getInvitationsApiV1Response>(getGetInvitationsApiV1Url(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetInvitationsApiV1QueryKey = () => {
    return [`http://localhost:8888/api/v1/workspaces/invitations`] as const;
    }

    
export const getGetInvitationsApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getInvitationsApiV1>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvitationsApiV1QueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvitationsApiV1>>> = ({ signal }) => getInvitationsApiV1({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvitationsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvitationsApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getInvitationsApiV1>>>
export type GetInvitationsApiV1QueryError = unknown


export function useGetInvitationsApiV1<TData = Awaited<ReturnType<typeof getInvitationsApiV1>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationsApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getInvitationsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationsApiV1<TData = Awaited<ReturnType<typeof getInvitationsApiV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationsApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getInvitationsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationsApiV1<TData = Awaited<ReturnType<typeof getInvitationsApiV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all invitations for the current user
 */

export function useGetInvitationsApiV1<TData = Awaited<ReturnType<typeof getInvitationsApiV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvitationsApiV1QueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetInvitationsApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getInvitationsApiV1>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvitationsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvitationsApiV1QueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvitationsApiV1>>> = ({ signal }) => getInvitationsApiV1({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvitationsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvitationsApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getInvitationsApiV1>>>
export type GetInvitationsApiV1SuspenseQueryError = unknown


export function useGetInvitationsApiV1Suspense<TData = Awaited<ReturnType<typeof getInvitationsApiV1>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvitationsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationsApiV1Suspense<TData = Awaited<ReturnType<typeof getInvitationsApiV1>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvitationsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationsApiV1Suspense<TData = Awaited<ReturnType<typeof getInvitationsApiV1>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvitationsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all invitations for the current user
 */

export function useGetInvitationsApiV1Suspense<TData = Awaited<ReturnType<typeof getInvitationsApiV1>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvitationsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvitationsApiV1SuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get a specific invitation
 */
export type getInvitationApiV1Response200 = {
  data: GetWorkspaceInvitaitonResponseDto
  status: 200
}
    
export type getInvitationApiV1ResponseComposite = getInvitationApiV1Response200;
    
export type getInvitationApiV1Response = getInvitationApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetInvitationApiV1Url = (invitationId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/invitations/${invitationId}`
}

export const getInvitationApiV1 = async (invitationId: string, options?: RequestInit): Promise<getInvitationApiV1Response> => {
  
  return apiClient<getInvitationApiV1Response>(getGetInvitationApiV1Url(invitationId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetInvitationApiV1QueryKey = (invitationId: string,) => {
    return [`http://localhost:8888/api/v1/workspaces/invitations/${invitationId}`] as const;
    }

    
export const getGetInvitationApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getInvitationApiV1>>, TError = unknown>(invitationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvitationApiV1QueryKey(invitationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvitationApiV1>>> = ({ signal }) => getInvitationApiV1(invitationId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(invitationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvitationApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvitationApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getInvitationApiV1>>>
export type GetInvitationApiV1QueryError = unknown


export function useGetInvitationApiV1<TData = Awaited<ReturnType<typeof getInvitationApiV1>>, TError = unknown>(
 invitationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationApiV1>>,
          TError,
          Awaited<ReturnType<typeof getInvitationApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationApiV1<TData = Awaited<ReturnType<typeof getInvitationApiV1>>, TError = unknown>(
 invitationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationApiV1>>,
          TError,
          Awaited<ReturnType<typeof getInvitationApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationApiV1<TData = Awaited<ReturnType<typeof getInvitationApiV1>>, TError = unknown>(
 invitationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific invitation
 */

export function useGetInvitationApiV1<TData = Awaited<ReturnType<typeof getInvitationApiV1>>, TError = unknown>(
 invitationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvitationApiV1QueryOptions(invitationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetInvitationApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getInvitationApiV1>>, TError = unknown>(invitationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvitationApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvitationApiV1QueryKey(invitationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvitationApiV1>>> = ({ signal }) => getInvitationApiV1(invitationId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvitationApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvitationApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getInvitationApiV1>>>
export type GetInvitationApiV1SuspenseQueryError = unknown


export function useGetInvitationApiV1Suspense<TData = Awaited<ReturnType<typeof getInvitationApiV1>>, TError = unknown>(
 invitationId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvitationApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationApiV1Suspense<TData = Awaited<ReturnType<typeof getInvitationApiV1>>, TError = unknown>(
 invitationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvitationApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationApiV1Suspense<TData = Awaited<ReturnType<typeof getInvitationApiV1>>, TError = unknown>(
 invitationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvitationApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific invitation
 */

export function useGetInvitationApiV1Suspense<TData = Awaited<ReturnType<typeof getInvitationApiV1>>, TError = unknown>(
 invitationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInvitationApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvitationApiV1SuspenseQueryOptions(invitationId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Accept an invitation (only for the invited user)
 */
export type acceptInvitationApiV1Response204 = {
  data: void
  status: 204
}

export type acceptInvitationApiV1Response403 = {
  data: void
  status: 403
}
    
export type acceptInvitationApiV1ResponseComposite = acceptInvitationApiV1Response204 | acceptInvitationApiV1Response403;
    
export type acceptInvitationApiV1Response = acceptInvitationApiV1ResponseComposite & {
  headers: Headers;
}

export const getAcceptInvitationApiV1Url = (invitationId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/invitations/${invitationId}/accept`
}

export const acceptInvitationApiV1 = async (invitationId: string, options?: RequestInit): Promise<acceptInvitationApiV1Response> => {
  
  return apiClient<acceptInvitationApiV1Response>(getAcceptInvitationApiV1Url(invitationId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcceptInvitationApiV1MutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInvitationApiV1>>, TError,{invitationId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptInvitationApiV1>>, TError,{invitationId: string}, TContext> => {
    
const mutationKey = ['acceptInvitationApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptInvitationApiV1>>, {invitationId: string}> = (props) => {
          const {invitationId} = props ?? {};

          return  acceptInvitationApiV1(invitationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcceptInvitationApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof acceptInvitationApiV1>>>
    
    export type AcceptInvitationApiV1MutationError = void

    /**
 * @summary Accept an invitation (only for the invited user)
 */
export const useAcceptInvitationApiV1 = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInvitationApiV1>>, TError,{invitationId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof acceptInvitationApiV1>>,
        TError,
        {invitationId: string},
        TContext
      > => {

      const mutationOptions = getAcceptInvitationApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Decline an invitation (only for the invited user)
 */
export type declineInvitationApiV1Response204 = {
  data: void
  status: 204
}

export type declineInvitationApiV1Response403 = {
  data: void
  status: 403
}
    
export type declineInvitationApiV1ResponseComposite = declineInvitationApiV1Response204 | declineInvitationApiV1Response403;
    
export type declineInvitationApiV1Response = declineInvitationApiV1ResponseComposite & {
  headers: Headers;
}

export const getDeclineInvitationApiV1Url = (invitationId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/invitations/${invitationId}/decline`
}

export const declineInvitationApiV1 = async (invitationId: string, options?: RequestInit): Promise<declineInvitationApiV1Response> => {
  
  return apiClient<declineInvitationApiV1Response>(getDeclineInvitationApiV1Url(invitationId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getDeclineInvitationApiV1MutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineInvitationApiV1>>, TError,{invitationId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof declineInvitationApiV1>>, TError,{invitationId: string}, TContext> => {
    
const mutationKey = ['declineInvitationApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof declineInvitationApiV1>>, {invitationId: string}> = (props) => {
          const {invitationId} = props ?? {};

          return  declineInvitationApiV1(invitationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeclineInvitationApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof declineInvitationApiV1>>>
    
    export type DeclineInvitationApiV1MutationError = void

    /**
 * @summary Decline an invitation (only for the invited user)
 */
export const useDeclineInvitationApiV1 = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineInvitationApiV1>>, TError,{invitationId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof declineInvitationApiV1>>,
        TError,
        {invitationId: string},
        TContext
      > => {

      const mutationOptions = getDeclineInvitationApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Get all workspaces for the current user
 */
export type getWorkspacesApiV1Response200 = {
  data: GetWorkspacesResponseDto
  status: 200
}
    
export type getWorkspacesApiV1ResponseComposite = getWorkspacesApiV1Response200;
    
export type getWorkspacesApiV1Response = getWorkspacesApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetWorkspacesApiV1Url = () => {


  

  return `http://localhost:8888/api/v1/workspaces`
}

export const getWorkspacesApiV1 = async ( options?: RequestInit): Promise<getWorkspacesApiV1Response> => {
  
  return apiClient<getWorkspacesApiV1Response>(getGetWorkspacesApiV1Url(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetWorkspacesApiV1QueryKey = () => {
    return [`http://localhost:8888/api/v1/workspaces`] as const;
    }

    
export const getGetWorkspacesApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getWorkspacesApiV1>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspacesApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkspacesApiV1QueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspacesApiV1>>> = ({ signal }) => getWorkspacesApiV1({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkspacesApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkspacesApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getWorkspacesApiV1>>>
export type GetWorkspacesApiV1QueryError = unknown


export function useGetWorkspacesApiV1<TData = Awaited<ReturnType<typeof getWorkspacesApiV1>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspacesApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspacesApiV1>>,
          TError,
          Awaited<ReturnType<typeof getWorkspacesApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspacesApiV1<TData = Awaited<ReturnType<typeof getWorkspacesApiV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspacesApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspacesApiV1>>,
          TError,
          Awaited<ReturnType<typeof getWorkspacesApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspacesApiV1<TData = Awaited<ReturnType<typeof getWorkspacesApiV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspacesApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all workspaces for the current user
 */

export function useGetWorkspacesApiV1<TData = Awaited<ReturnType<typeof getWorkspacesApiV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspacesApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkspacesApiV1QueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetWorkspacesApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getWorkspacesApiV1>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspacesApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkspacesApiV1QueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspacesApiV1>>> = ({ signal }) => getWorkspacesApiV1({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspacesApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkspacesApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkspacesApiV1>>>
export type GetWorkspacesApiV1SuspenseQueryError = unknown


export function useGetWorkspacesApiV1Suspense<TData = Awaited<ReturnType<typeof getWorkspacesApiV1>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspacesApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspacesApiV1Suspense<TData = Awaited<ReturnType<typeof getWorkspacesApiV1>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspacesApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspacesApiV1Suspense<TData = Awaited<ReturnType<typeof getWorkspacesApiV1>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspacesApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all workspaces for the current user
 */

export function useGetWorkspacesApiV1Suspense<TData = Awaited<ReturnType<typeof getWorkspacesApiV1>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspacesApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkspacesApiV1SuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get a specific workspace
 */
export type getWorkspaceApiV1Response200 = {
  data: GetWorkspaceResponseDto
  status: 200
}
    
export type getWorkspaceApiV1ResponseComposite = getWorkspaceApiV1Response200;
    
export type getWorkspaceApiV1Response = getWorkspaceApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetWorkspaceApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}`
}

export const getWorkspaceApiV1 = async (workspaceId: string, options?: RequestInit): Promise<getWorkspaceApiV1Response> => {
  
  return apiClient<getWorkspaceApiV1Response>(getGetWorkspaceApiV1Url(workspaceId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetWorkspaceApiV1QueryKey = (workspaceId: string,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}`] as const;
    }

    
export const getGetWorkspaceApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getWorkspaceApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkspaceApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspaceApiV1>>> = ({ signal }) => getWorkspaceApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkspaceApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getWorkspaceApiV1>>>
export type GetWorkspaceApiV1QueryError = unknown


export function useGetWorkspaceApiV1<TData = Awaited<ReturnType<typeof getWorkspaceApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspaceApiV1>>,
          TError,
          Awaited<ReturnType<typeof getWorkspaceApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspaceApiV1<TData = Awaited<ReturnType<typeof getWorkspaceApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspaceApiV1>>,
          TError,
          Awaited<ReturnType<typeof getWorkspaceApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspaceApiV1<TData = Awaited<ReturnType<typeof getWorkspaceApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific workspace
 */

export function useGetWorkspaceApiV1<TData = Awaited<ReturnType<typeof getWorkspaceApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkspaceApiV1QueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetWorkspaceApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getWorkspaceApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkspaceApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspaceApiV1>>> = ({ signal }) => getWorkspaceApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkspaceApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkspaceApiV1>>>
export type GetWorkspaceApiV1SuspenseQueryError = unknown


export function useGetWorkspaceApiV1Suspense<TData = Awaited<ReturnType<typeof getWorkspaceApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspaceApiV1Suspense<TData = Awaited<ReturnType<typeof getWorkspaceApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspaceApiV1Suspense<TData = Awaited<ReturnType<typeof getWorkspaceApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific workspace
 */

export function useGetWorkspaceApiV1Suspense<TData = Awaited<ReturnType<typeof getWorkspaceApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkspaceApiV1SuspenseQueryOptions(workspaceId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete a workspace
 */
export type deleteWorkspaceApiV1Response204 = {
  data: void
  status: 204
}
    
export type deleteWorkspaceApiV1ResponseComposite = deleteWorkspaceApiV1Response204;
    
export type deleteWorkspaceApiV1Response = deleteWorkspaceApiV1ResponseComposite & {
  headers: Headers;
}

export const getDeleteWorkspaceApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}`
}

export const deleteWorkspaceApiV1 = async (workspaceId: string, options?: RequestInit): Promise<deleteWorkspaceApiV1Response> => {
  
  return apiClient<deleteWorkspaceApiV1Response>(getDeleteWorkspaceApiV1Url(workspaceId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getDeleteWorkspaceApiV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkspaceApiV1>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteWorkspaceApiV1>>, TError,{workspaceId: string}, TContext> => {
    
const mutationKey = ['deleteWorkspaceApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWorkspaceApiV1>>, {workspaceId: string}> = (props) => {
          const {workspaceId} = props ?? {};

          return  deleteWorkspaceApiV1(workspaceId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteWorkspaceApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof deleteWorkspaceApiV1>>>
    
    export type DeleteWorkspaceApiV1MutationError = unknown

    /**
 * @summary Delete a workspace
 */
export const useDeleteWorkspaceApiV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkspaceApiV1>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteWorkspaceApiV1>>,
        TError,
        {workspaceId: string},
        TContext
      > => {

      const mutationOptions = getDeleteWorkspaceApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Update a workspace
 */
export type updateWorkspaceApiV1Response204 = {
  data: void
  status: 204
}
    
export type updateWorkspaceApiV1ResponseComposite = updateWorkspaceApiV1Response204;
    
export type updateWorkspaceApiV1Response = updateWorkspaceApiV1ResponseComposite & {
  headers: Headers;
}

export const getUpdateWorkspaceApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}`
}

export const updateWorkspaceApiV1 = async (workspaceId: string,
    updateWorkspaceRequestDto: UpdateWorkspaceRequestDto, options?: RequestInit): Promise<updateWorkspaceApiV1Response> => {
  
  return apiClient<updateWorkspaceApiV1Response>(getUpdateWorkspaceApiV1Url(workspaceId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateWorkspaceRequestDto,)
  }
);}




export const getUpdateWorkspaceApiV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkspaceApiV1>>, TError,{workspaceId: string;data: UpdateWorkspaceRequestDto}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof updateWorkspaceApiV1>>, TError,{workspaceId: string;data: UpdateWorkspaceRequestDto}, TContext> => {
    
const mutationKey = ['updateWorkspaceApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorkspaceApiV1>>, {workspaceId: string;data: UpdateWorkspaceRequestDto}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  updateWorkspaceApiV1(workspaceId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorkspaceApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof updateWorkspaceApiV1>>>
    export type UpdateWorkspaceApiV1MutationBody = UpdateWorkspaceRequestDto
    export type UpdateWorkspaceApiV1MutationError = unknown

    /**
 * @summary Update a workspace
 */
export const useUpdateWorkspaceApiV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkspaceApiV1>>, TError,{workspaceId: string;data: UpdateWorkspaceRequestDto}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateWorkspaceApiV1>>,
        TError,
        {workspaceId: string;data: UpdateWorkspaceRequestDto},
        TContext
      > => {

      const mutationOptions = getUpdateWorkspaceApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Get a specific workspace for the current user
 */
export type getWorkspaceMeApiV1Response200 = {
  data: GetWorkspaceMeResponseDto
  status: 200
}
    
export type getWorkspaceMeApiV1ResponseComposite = getWorkspaceMeApiV1Response200;
    
export type getWorkspaceMeApiV1Response = getWorkspaceMeApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetWorkspaceMeApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/me`
}

export const getWorkspaceMeApiV1 = async (workspaceId: string, options?: RequestInit): Promise<getWorkspaceMeApiV1Response> => {
  
  return apiClient<getWorkspaceMeApiV1Response>(getGetWorkspaceMeApiV1Url(workspaceId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetWorkspaceMeApiV1QueryKey = (workspaceId: string,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/me`] as const;
    }

    
export const getGetWorkspaceMeApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getWorkspaceMeApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMeApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkspaceMeApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspaceMeApiV1>>> = ({ signal }) => getWorkspaceMeApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMeApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkspaceMeApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getWorkspaceMeApiV1>>>
export type GetWorkspaceMeApiV1QueryError = unknown


export function useGetWorkspaceMeApiV1<TData = Awaited<ReturnType<typeof getWorkspaceMeApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMeApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspaceMeApiV1>>,
          TError,
          Awaited<ReturnType<typeof getWorkspaceMeApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspaceMeApiV1<TData = Awaited<ReturnType<typeof getWorkspaceMeApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMeApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspaceMeApiV1>>,
          TError,
          Awaited<ReturnType<typeof getWorkspaceMeApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspaceMeApiV1<TData = Awaited<ReturnType<typeof getWorkspaceMeApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMeApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific workspace for the current user
 */

export function useGetWorkspaceMeApiV1<TData = Awaited<ReturnType<typeof getWorkspaceMeApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMeApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkspaceMeApiV1QueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetWorkspaceMeApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getWorkspaceMeApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMeApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkspaceMeApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspaceMeApiV1>>> = ({ signal }) => getWorkspaceMeApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMeApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkspaceMeApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkspaceMeApiV1>>>
export type GetWorkspaceMeApiV1SuspenseQueryError = unknown


export function useGetWorkspaceMeApiV1Suspense<TData = Awaited<ReturnType<typeof getWorkspaceMeApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMeApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspaceMeApiV1Suspense<TData = Awaited<ReturnType<typeof getWorkspaceMeApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMeApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspaceMeApiV1Suspense<TData = Awaited<ReturnType<typeof getWorkspaceMeApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMeApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific workspace for the current user
 */

export function useGetWorkspaceMeApiV1Suspense<TData = Awaited<ReturnType<typeof getWorkspaceMeApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMeApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkspaceMeApiV1SuspenseQueryOptions(workspaceId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get a specific member of a workspace
 */
export type getWorkspaceMemberApiV1Response200 = {
  data: GetWorkspaceMemberResponseDto
  status: 200
}
    
export type getWorkspaceMemberApiV1ResponseComposite = getWorkspaceMemberApiV1Response200;
    
export type getWorkspaceMemberApiV1Response = getWorkspaceMemberApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetWorkspaceMemberApiV1Url = (workspaceId: string,
    userId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/members/${userId}`
}

export const getWorkspaceMemberApiV1 = async (workspaceId: string,
    userId: string, options?: RequestInit): Promise<getWorkspaceMemberApiV1Response> => {
  
  return apiClient<getWorkspaceMemberApiV1Response>(getGetWorkspaceMemberApiV1Url(workspaceId,userId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetWorkspaceMemberApiV1QueryKey = (workspaceId: string,
    userId: string,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/members/${userId}`] as const;
    }

    
export const getGetWorkspaceMemberApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>, TError = unknown>(workspaceId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkspaceMemberApiV1QueryKey(workspaceId,userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>> = ({ signal }) => getWorkspaceMemberApiV1(workspaceId,userId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkspaceMemberApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>>
export type GetWorkspaceMemberApiV1QueryError = unknown


export function useGetWorkspaceMemberApiV1<TData = Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>, TError = unknown>(
 workspaceId: string,
    userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>,
          TError,
          Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspaceMemberApiV1<TData = Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>, TError = unknown>(
 workspaceId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>,
          TError,
          Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspaceMemberApiV1<TData = Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>, TError = unknown>(
 workspaceId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific member of a workspace
 */

export function useGetWorkspaceMemberApiV1<TData = Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>, TError = unknown>(
 workspaceId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkspaceMemberApiV1QueryOptions(workspaceId,userId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetWorkspaceMemberApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>, TError = unknown>(workspaceId: string,
    userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkspaceMemberApiV1QueryKey(workspaceId,userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>> = ({ signal }) => getWorkspaceMemberApiV1(workspaceId,userId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkspaceMemberApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>>
export type GetWorkspaceMemberApiV1SuspenseQueryError = unknown


export function useGetWorkspaceMemberApiV1Suspense<TData = Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>, TError = unknown>(
 workspaceId: string,
    userId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspaceMemberApiV1Suspense<TData = Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>, TError = unknown>(
 workspaceId: string,
    userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspaceMemberApiV1Suspense<TData = Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>, TError = unknown>(
 workspaceId: string,
    userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific member of a workspace
 */

export function useGetWorkspaceMemberApiV1Suspense<TData = Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>, TError = unknown>(
 workspaceId: string,
    userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMemberApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkspaceMemberApiV1SuspenseQueryOptions(workspaceId,userId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update a workspace member
 */
export type updateWorkspaceMemberApiV1Response204 = {
  data: void
  status: 204
}
    
export type updateWorkspaceMemberApiV1ResponseComposite = updateWorkspaceMemberApiV1Response204;
    
export type updateWorkspaceMemberApiV1Response = updateWorkspaceMemberApiV1ResponseComposite & {
  headers: Headers;
}

export const getUpdateWorkspaceMemberApiV1Url = (workspaceId: string,
    userId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/members/${userId}`
}

export const updateWorkspaceMemberApiV1 = async (workspaceId: string,
    userId: string,
    updateWorkspaceMemberRequestDto: UpdateWorkspaceMemberRequestDto, options?: RequestInit): Promise<updateWorkspaceMemberApiV1Response> => {
  
  return apiClient<updateWorkspaceMemberApiV1Response>(getUpdateWorkspaceMemberApiV1Url(workspaceId,userId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateWorkspaceMemberRequestDto,)
  }
);}




export const getUpdateWorkspaceMemberApiV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkspaceMemberApiV1>>, TError,{workspaceId: string;userId: string;data: UpdateWorkspaceMemberRequestDto}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof updateWorkspaceMemberApiV1>>, TError,{workspaceId: string;userId: string;data: UpdateWorkspaceMemberRequestDto}, TContext> => {
    
const mutationKey = ['updateWorkspaceMemberApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorkspaceMemberApiV1>>, {workspaceId: string;userId: string;data: UpdateWorkspaceMemberRequestDto}> = (props) => {
          const {workspaceId,userId,data} = props ?? {};

          return  updateWorkspaceMemberApiV1(workspaceId,userId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorkspaceMemberApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof updateWorkspaceMemberApiV1>>>
    export type UpdateWorkspaceMemberApiV1MutationBody = UpdateWorkspaceMemberRequestDto
    export type UpdateWorkspaceMemberApiV1MutationError = unknown

    /**
 * @summary Update a workspace member
 */
export const useUpdateWorkspaceMemberApiV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkspaceMemberApiV1>>, TError,{workspaceId: string;userId: string;data: UpdateWorkspaceMemberRequestDto}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateWorkspaceMemberApiV1>>,
        TError,
        {workspaceId: string;userId: string;data: UpdateWorkspaceMemberRequestDto},
        TContext
      > => {

      const mutationOptions = getUpdateWorkspaceMemberApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Delete a workspace member
 */
export type deleteWorkspaceMemberApiV1Response204 = {
  data: void
  status: 204
}
    
export type deleteWorkspaceMemberApiV1ResponseComposite = deleteWorkspaceMemberApiV1Response204;
    
export type deleteWorkspaceMemberApiV1Response = deleteWorkspaceMemberApiV1ResponseComposite & {
  headers: Headers;
}

export const getDeleteWorkspaceMemberApiV1Url = (workspaceId: string,
    userId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/members/${userId}`
}

export const deleteWorkspaceMemberApiV1 = async (workspaceId: string,
    userId: string, options?: RequestInit): Promise<deleteWorkspaceMemberApiV1Response> => {
  
  return apiClient<deleteWorkspaceMemberApiV1Response>(getDeleteWorkspaceMemberApiV1Url(workspaceId,userId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getDeleteWorkspaceMemberApiV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkspaceMemberApiV1>>, TError,{workspaceId: string;userId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteWorkspaceMemberApiV1>>, TError,{workspaceId: string;userId: string}, TContext> => {
    
const mutationKey = ['deleteWorkspaceMemberApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWorkspaceMemberApiV1>>, {workspaceId: string;userId: string}> = (props) => {
          const {workspaceId,userId} = props ?? {};

          return  deleteWorkspaceMemberApiV1(workspaceId,userId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteWorkspaceMemberApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof deleteWorkspaceMemberApiV1>>>
    
    export type DeleteWorkspaceMemberApiV1MutationError = unknown

    /**
 * @summary Delete a workspace member
 */
export const useDeleteWorkspaceMemberApiV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkspaceMemberApiV1>>, TError,{workspaceId: string;userId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteWorkspaceMemberApiV1>>,
        TError,
        {workspaceId: string;userId: string},
        TContext
      > => {

      const mutationOptions = getDeleteWorkspaceMemberApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Get all members of a workspace
 */
export type getWorkspaceMembersApiV1Response200 = {
  data: GetWorkspaceMembersResponseDto
  status: 200
}
    
export type getWorkspaceMembersApiV1ResponseComposite = getWorkspaceMembersApiV1Response200;
    
export type getWorkspaceMembersApiV1Response = getWorkspaceMembersApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetWorkspaceMembersApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/members`
}

export const getWorkspaceMembersApiV1 = async (workspaceId: string, options?: RequestInit): Promise<getWorkspaceMembersApiV1Response> => {
  
  return apiClient<getWorkspaceMembersApiV1Response>(getGetWorkspaceMembersApiV1Url(workspaceId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetWorkspaceMembersApiV1QueryKey = (workspaceId: string,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/members`] as const;
    }

    
export const getGetWorkspaceMembersApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkspaceMembersApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>> = ({ signal }) => getWorkspaceMembersApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkspaceMembersApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>>
export type GetWorkspaceMembersApiV1QueryError = unknown


export function useGetWorkspaceMembersApiV1<TData = Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>,
          TError,
          Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspaceMembersApiV1<TData = Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>,
          TError,
          Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspaceMembersApiV1<TData = Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all members of a workspace
 */

export function useGetWorkspaceMembersApiV1<TData = Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkspaceMembersApiV1QueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetWorkspaceMembersApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkspaceMembersApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>> = ({ signal }) => getWorkspaceMembersApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkspaceMembersApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>>
export type GetWorkspaceMembersApiV1SuspenseQueryError = unknown


export function useGetWorkspaceMembersApiV1Suspense<TData = Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspaceMembersApiV1Suspense<TData = Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspaceMembersApiV1Suspense<TData = Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all members of a workspace
 */

export function useGetWorkspaceMembersApiV1Suspense<TData = Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMembersApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkspaceMembersApiV1SuspenseQueryOptions(workspaceId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Leave a workspace
 */
export type leaveWorkspaceApiV1Response204 = {
  data: void
  status: 204
}
    
export type leaveWorkspaceApiV1ResponseComposite = leaveWorkspaceApiV1Response204;
    
export type leaveWorkspaceApiV1Response = leaveWorkspaceApiV1ResponseComposite & {
  headers: Headers;
}

export const getLeaveWorkspaceApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/leave`
}

export const leaveWorkspaceApiV1 = async (workspaceId: string, options?: RequestInit): Promise<leaveWorkspaceApiV1Response> => {
  
  return apiClient<leaveWorkspaceApiV1Response>(getLeaveWorkspaceApiV1Url(workspaceId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getLeaveWorkspaceApiV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leaveWorkspaceApiV1>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof leaveWorkspaceApiV1>>, TError,{workspaceId: string}, TContext> => {
    
const mutationKey = ['leaveWorkspaceApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof leaveWorkspaceApiV1>>, {workspaceId: string}> = (props) => {
          const {workspaceId} = props ?? {};

          return  leaveWorkspaceApiV1(workspaceId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LeaveWorkspaceApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof leaveWorkspaceApiV1>>>
    
    export type LeaveWorkspaceApiV1MutationError = unknown

    /**
 * @summary Leave a workspace
 */
export const useLeaveWorkspaceApiV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leaveWorkspaceApiV1>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof leaveWorkspaceApiV1>>,
        TError,
        {workspaceId: string},
        TContext
      > => {

      const mutationOptions = getLeaveWorkspaceApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Get all invitations for a specific workspace
 */
export type getWorkspaceInvitationsApiV1Response200 = {
  data: GetWorkspaceInvitaitonsResponseDto
  status: 200
}
    
export type getWorkspaceInvitationsApiV1ResponseComposite = getWorkspaceInvitationsApiV1Response200;
    
export type getWorkspaceInvitationsApiV1Response = getWorkspaceInvitationsApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetWorkspaceInvitationsApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/invitations`
}

export const getWorkspaceInvitationsApiV1 = async (workspaceId: string, options?: RequestInit): Promise<getWorkspaceInvitationsApiV1Response> => {
  
  return apiClient<getWorkspaceInvitationsApiV1Response>(getGetWorkspaceInvitationsApiV1Url(workspaceId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetWorkspaceInvitationsApiV1QueryKey = (workspaceId: string,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/invitations`] as const;
    }

    
export const getGetWorkspaceInvitationsApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkspaceInvitationsApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>> = ({ signal }) => getWorkspaceInvitationsApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkspaceInvitationsApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>>
export type GetWorkspaceInvitationsApiV1QueryError = unknown


export function useGetWorkspaceInvitationsApiV1<TData = Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspaceInvitationsApiV1<TData = Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspaceInvitationsApiV1<TData = Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all invitations for a specific workspace
 */

export function useGetWorkspaceInvitationsApiV1<TData = Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkspaceInvitationsApiV1QueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetWorkspaceInvitationsApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkspaceInvitationsApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>> = ({ signal }) => getWorkspaceInvitationsApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkspaceInvitationsApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>>
export type GetWorkspaceInvitationsApiV1SuspenseQueryError = unknown


export function useGetWorkspaceInvitationsApiV1Suspense<TData = Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspaceInvitationsApiV1Suspense<TData = Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspaceInvitationsApiV1Suspense<TData = Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all invitations for a specific workspace
 */

export function useGetWorkspaceInvitationsApiV1Suspense<TData = Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkspaceInvitationsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkspaceInvitationsApiV1SuspenseQueryOptions(workspaceId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a new invitation
 */
export type createInvitationApiV1Response201 = {
  data: void
  status: 201
}
    
export type createInvitationApiV1ResponseComposite = createInvitationApiV1Response201;
    
export type createInvitationApiV1Response = createInvitationApiV1ResponseComposite & {
  headers: Headers;
}

export const getCreateInvitationApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/invitations`
}

export const createInvitationApiV1 = async (workspaceId: string,
    createInvitationRequestDto: CreateInvitationRequestDto, options?: RequestInit): Promise<createInvitationApiV1Response> => {
  
  return apiClient<createInvitationApiV1Response>(getCreateInvitationApiV1Url(workspaceId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createInvitationRequestDto,)
  }
);}




export const getCreateInvitationApiV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvitationApiV1>>, TError,{workspaceId: string;data: CreateInvitationRequestDto}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createInvitationApiV1>>, TError,{workspaceId: string;data: CreateInvitationRequestDto}, TContext> => {
    
const mutationKey = ['createInvitationApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInvitationApiV1>>, {workspaceId: string;data: CreateInvitationRequestDto}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createInvitationApiV1(workspaceId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateInvitationApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof createInvitationApiV1>>>
    export type CreateInvitationApiV1MutationBody = CreateInvitationRequestDto
    export type CreateInvitationApiV1MutationError = unknown

    /**
 * @summary Create a new invitation
 */
export const useCreateInvitationApiV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvitationApiV1>>, TError,{workspaceId: string;data: CreateInvitationRequestDto}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof createInvitationApiV1>>,
        TError,
        {workspaceId: string;data: CreateInvitationRequestDto},
        TContext
      > => {

      const mutationOptions = getCreateInvitationApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Cancel an invitation (only for admins)
 */
export type cancelInvitationApiV1Response204 = {
  data: void
  status: 204
}
    
export type cancelInvitationApiV1ResponseComposite = cancelInvitationApiV1Response204;
    
export type cancelInvitationApiV1Response = cancelInvitationApiV1ResponseComposite & {
  headers: Headers;
}

export const getCancelInvitationApiV1Url = (workspaceId: string,
    invitationId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/invitations/${invitationId}/cancel`
}

export const cancelInvitationApiV1 = async (workspaceId: string,
    invitationId: string, options?: RequestInit): Promise<cancelInvitationApiV1Response> => {
  
  return apiClient<cancelInvitationApiV1Response>(getCancelInvitationApiV1Url(workspaceId,invitationId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getCancelInvitationApiV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelInvitationApiV1>>, TError,{workspaceId: string;invitationId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelInvitationApiV1>>, TError,{workspaceId: string;invitationId: string}, TContext> => {
    
const mutationKey = ['cancelInvitationApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelInvitationApiV1>>, {workspaceId: string;invitationId: string}> = (props) => {
          const {workspaceId,invitationId} = props ?? {};

          return  cancelInvitationApiV1(workspaceId,invitationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelInvitationApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof cancelInvitationApiV1>>>
    
    export type CancelInvitationApiV1MutationError = unknown

    /**
 * @summary Cancel an invitation (only for admins)
 */
export const useCancelInvitationApiV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelInvitationApiV1>>, TError,{workspaceId: string;invitationId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof cancelInvitationApiV1>>,
        TError,
        {workspaceId: string;invitationId: string},
        TContext
      > => {

      const mutationOptions = getCancelInvitationApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export type deleteUserApiV1Response204 = {
  data: void
  status: 204
}
    
export type deleteUserApiV1ResponseComposite = deleteUserApiV1Response204;
    
export type deleteUserApiV1Response = deleteUserApiV1ResponseComposite & {
  headers: Headers;
}

export const getDeleteUserApiV1Url = () => {


  

  return `http://localhost:8888/api/v1/users`
}

export const deleteUserApiV1 = async ( options?: RequestInit): Promise<deleteUserApiV1Response> => {
  
  return apiClient<deleteUserApiV1Response>(getDeleteUserApiV1Url(),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getDeleteUserApiV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserApiV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserApiV1>>, TError,void, TContext> => {
    
const mutationKey = ['deleteUserApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserApiV1>>, void> = () => {
          

          return  deleteUserApiV1(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserApiV1>>>
    
    export type DeleteUserApiV1MutationError = unknown

    export const useDeleteUserApiV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserApiV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteUserApiV1>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getDeleteUserApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export type getCampaignsApiV1Response200 = {
  data: GetCampaignsResponseDTO
  status: 200
}
    
export type getCampaignsApiV1ResponseComposite = getCampaignsApiV1Response200;
    
export type getCampaignsApiV1Response = getCampaignsApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetCampaignsApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/campaigns`
}

export const getCampaignsApiV1 = async (workspaceId: string, options?: RequestInit): Promise<getCampaignsApiV1Response> => {
  
  return apiClient<getCampaignsApiV1Response>(getGetCampaignsApiV1Url(workspaceId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetCampaignsApiV1QueryKey = (workspaceId: string,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/campaigns`] as const;
    }

    
export const getGetCampaignsApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getCampaignsApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampaignsApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignsApiV1>>> = ({ signal }) => getCampaignsApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCampaignsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignsApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getCampaignsApiV1>>>
export type GetCampaignsApiV1QueryError = unknown


export function useGetCampaignsApiV1<TData = Awaited<ReturnType<typeof getCampaignsApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignsApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getCampaignsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignsApiV1<TData = Awaited<ReturnType<typeof getCampaignsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignsApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getCampaignsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignsApiV1<TData = Awaited<ReturnType<typeof getCampaignsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCampaignsApiV1<TData = Awaited<ReturnType<typeof getCampaignsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCampaignsApiV1QueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCampaignsApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCampaignsApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCampaignsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampaignsApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignsApiV1>>> = ({ signal }) => getCampaignsApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCampaignsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignsApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCampaignsApiV1>>>
export type GetCampaignsApiV1SuspenseQueryError = unknown


export function useGetCampaignsApiV1Suspense<TData = Awaited<ReturnType<typeof getCampaignsApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCampaignsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignsApiV1Suspense<TData = Awaited<ReturnType<typeof getCampaignsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCampaignsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignsApiV1Suspense<TData = Awaited<ReturnType<typeof getCampaignsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCampaignsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCampaignsApiV1Suspense<TData = Awaited<ReturnType<typeof getCampaignsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCampaignsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCampaignsApiV1SuspenseQueryOptions(workspaceId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type getAllCampaignsApiV1Response200 = {
  data: GetCampaignsResponseDTO
  status: 200
}
    
export type getAllCampaignsApiV1ResponseComposite = getAllCampaignsApiV1Response200;
    
export type getAllCampaignsApiV1Response = getAllCampaignsApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetAllCampaignsApiV1Url = (workspaceId: unknown,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/campaigns/all`
}

export const getAllCampaignsApiV1 = async (workspaceId: unknown, options?: RequestInit): Promise<getAllCampaignsApiV1Response> => {
  
  return apiClient<getAllCampaignsApiV1Response>(getGetAllCampaignsApiV1Url(workspaceId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetAllCampaignsApiV1QueryKey = (workspaceId: unknown,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/campaigns/all`] as const;
    }

    
export const getGetAllCampaignsApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getAllCampaignsApiV1>>, TError = unknown>(workspaceId: unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCampaignsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllCampaignsApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllCampaignsApiV1>>> = ({ signal }) => getAllCampaignsApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllCampaignsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllCampaignsApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getAllCampaignsApiV1>>>
export type GetAllCampaignsApiV1QueryError = unknown


export function useGetAllCampaignsApiV1<TData = Awaited<ReturnType<typeof getAllCampaignsApiV1>>, TError = unknown>(
 workspaceId: unknown, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCampaignsApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCampaignsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getAllCampaignsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllCampaignsApiV1<TData = Awaited<ReturnType<typeof getAllCampaignsApiV1>>, TError = unknown>(
 workspaceId: unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCampaignsApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCampaignsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getAllCampaignsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllCampaignsApiV1<TData = Awaited<ReturnType<typeof getAllCampaignsApiV1>>, TError = unknown>(
 workspaceId: unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCampaignsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAllCampaignsApiV1<TData = Awaited<ReturnType<typeof getAllCampaignsApiV1>>, TError = unknown>(
 workspaceId: unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCampaignsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllCampaignsApiV1QueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAllCampaignsApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAllCampaignsApiV1>>, TError = unknown>(workspaceId: unknown, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllCampaignsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllCampaignsApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllCampaignsApiV1>>> = ({ signal }) => getAllCampaignsApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllCampaignsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllCampaignsApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAllCampaignsApiV1>>>
export type GetAllCampaignsApiV1SuspenseQueryError = unknown


export function useGetAllCampaignsApiV1Suspense<TData = Awaited<ReturnType<typeof getAllCampaignsApiV1>>, TError = unknown>(
 workspaceId: unknown, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllCampaignsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllCampaignsApiV1Suspense<TData = Awaited<ReturnType<typeof getAllCampaignsApiV1>>, TError = unknown>(
 workspaceId: unknown, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllCampaignsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllCampaignsApiV1Suspense<TData = Awaited<ReturnType<typeof getAllCampaignsApiV1>>, TError = unknown>(
 workspaceId: unknown, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllCampaignsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAllCampaignsApiV1Suspense<TData = Awaited<ReturnType<typeof getAllCampaignsApiV1>>, TError = unknown>(
 workspaceId: unknown, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllCampaignsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllCampaignsApiV1SuspenseQueryOptions(workspaceId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type getCampaignApiV1Response200 = {
  data: GetCampaignResponseDTO
  status: 200
}
    
export type getCampaignApiV1ResponseComposite = getCampaignApiV1Response200;
    
export type getCampaignApiV1Response = getCampaignApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetCampaignApiV1Url = (workspaceId: string,
    campaignId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/campaigns/${campaignId}`
}

export const getCampaignApiV1 = async (workspaceId: string,
    campaignId: string, options?: RequestInit): Promise<getCampaignApiV1Response> => {
  
  return apiClient<getCampaignApiV1Response>(getGetCampaignApiV1Url(workspaceId,campaignId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetCampaignApiV1QueryKey = (workspaceId: string,
    campaignId: string,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/campaigns/${campaignId}`] as const;
    }

    
export const getGetCampaignApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getCampaignApiV1>>, TError = unknown>(workspaceId: string,
    campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampaignApiV1QueryKey(workspaceId,campaignId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignApiV1>>> = ({ signal }) => getCampaignApiV1(workspaceId,campaignId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && campaignId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCampaignApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getCampaignApiV1>>>
export type GetCampaignApiV1QueryError = unknown


export function useGetCampaignApiV1<TData = Awaited<ReturnType<typeof getCampaignApiV1>>, TError = unknown>(
 workspaceId: string,
    campaignId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignApiV1>>,
          TError,
          Awaited<ReturnType<typeof getCampaignApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignApiV1<TData = Awaited<ReturnType<typeof getCampaignApiV1>>, TError = unknown>(
 workspaceId: string,
    campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignApiV1>>,
          TError,
          Awaited<ReturnType<typeof getCampaignApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignApiV1<TData = Awaited<ReturnType<typeof getCampaignApiV1>>, TError = unknown>(
 workspaceId: string,
    campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCampaignApiV1<TData = Awaited<ReturnType<typeof getCampaignApiV1>>, TError = unknown>(
 workspaceId: string,
    campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCampaignApiV1QueryOptions(workspaceId,campaignId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCampaignApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCampaignApiV1>>, TError = unknown>(workspaceId: string,
    campaignId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCampaignApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampaignApiV1QueryKey(workspaceId,campaignId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignApiV1>>> = ({ signal }) => getCampaignApiV1(workspaceId,campaignId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCampaignApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCampaignApiV1>>>
export type GetCampaignApiV1SuspenseQueryError = unknown


export function useGetCampaignApiV1Suspense<TData = Awaited<ReturnType<typeof getCampaignApiV1>>, TError = unknown>(
 workspaceId: string,
    campaignId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCampaignApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignApiV1Suspense<TData = Awaited<ReturnType<typeof getCampaignApiV1>>, TError = unknown>(
 workspaceId: string,
    campaignId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCampaignApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignApiV1Suspense<TData = Awaited<ReturnType<typeof getCampaignApiV1>>, TError = unknown>(
 workspaceId: string,
    campaignId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCampaignApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCampaignApiV1Suspense<TData = Awaited<ReturnType<typeof getCampaignApiV1>>, TError = unknown>(
 workspaceId: string,
    campaignId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCampaignApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCampaignApiV1SuspenseQueryOptions(workspaceId,campaignId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type getCampaignEngagementApiV1Response200 = {
  data: GetCampaignEngagementResponseDTO
  status: 200
}
    
export type getCampaignEngagementApiV1ResponseComposite = getCampaignEngagementApiV1Response200;
    
export type getCampaignEngagementApiV1Response = getCampaignEngagementApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetCampaignEngagementApiV1Url = (workspaceId: string,
    campaignId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/campaigns/${campaignId}/engagement`
}

export const getCampaignEngagementApiV1 = async (workspaceId: string,
    campaignId: string, options?: RequestInit): Promise<getCampaignEngagementApiV1Response> => {
  
  return apiClient<getCampaignEngagementApiV1Response>(getGetCampaignEngagementApiV1Url(workspaceId,campaignId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetCampaignEngagementApiV1QueryKey = (workspaceId: string,
    campaignId: string,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/campaigns/${campaignId}/engagement`] as const;
    }

    
export const getGetCampaignEngagementApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getCampaignEngagementApiV1>>, TError = unknown>(workspaceId: string,
    campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignEngagementApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampaignEngagementApiV1QueryKey(workspaceId,campaignId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignEngagementApiV1>>> = ({ signal }) => getCampaignEngagementApiV1(workspaceId,campaignId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && campaignId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCampaignEngagementApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignEngagementApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getCampaignEngagementApiV1>>>
export type GetCampaignEngagementApiV1QueryError = unknown


export function useGetCampaignEngagementApiV1<TData = Awaited<ReturnType<typeof getCampaignEngagementApiV1>>, TError = unknown>(
 workspaceId: string,
    campaignId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignEngagementApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignEngagementApiV1>>,
          TError,
          Awaited<ReturnType<typeof getCampaignEngagementApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignEngagementApiV1<TData = Awaited<ReturnType<typeof getCampaignEngagementApiV1>>, TError = unknown>(
 workspaceId: string,
    campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignEngagementApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignEngagementApiV1>>,
          TError,
          Awaited<ReturnType<typeof getCampaignEngagementApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignEngagementApiV1<TData = Awaited<ReturnType<typeof getCampaignEngagementApiV1>>, TError = unknown>(
 workspaceId: string,
    campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignEngagementApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCampaignEngagementApiV1<TData = Awaited<ReturnType<typeof getCampaignEngagementApiV1>>, TError = unknown>(
 workspaceId: string,
    campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignEngagementApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCampaignEngagementApiV1QueryOptions(workspaceId,campaignId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCampaignEngagementApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCampaignEngagementApiV1>>, TError = unknown>(workspaceId: string,
    campaignId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCampaignEngagementApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampaignEngagementApiV1QueryKey(workspaceId,campaignId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignEngagementApiV1>>> = ({ signal }) => getCampaignEngagementApiV1(workspaceId,campaignId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCampaignEngagementApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignEngagementApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCampaignEngagementApiV1>>>
export type GetCampaignEngagementApiV1SuspenseQueryError = unknown


export function useGetCampaignEngagementApiV1Suspense<TData = Awaited<ReturnType<typeof getCampaignEngagementApiV1>>, TError = unknown>(
 workspaceId: string,
    campaignId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCampaignEngagementApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignEngagementApiV1Suspense<TData = Awaited<ReturnType<typeof getCampaignEngagementApiV1>>, TError = unknown>(
 workspaceId: string,
    campaignId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCampaignEngagementApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignEngagementApiV1Suspense<TData = Awaited<ReturnType<typeof getCampaignEngagementApiV1>>, TError = unknown>(
 workspaceId: string,
    campaignId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCampaignEngagementApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCampaignEngagementApiV1Suspense<TData = Awaited<ReturnType<typeof getCampaignEngagementApiV1>>, TError = unknown>(
 workspaceId: string,
    campaignId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCampaignEngagementApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCampaignEngagementApiV1SuspenseQueryOptions(workspaceId,campaignId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type joinCampaignYoutubeApiV1Response204 = {
  data: void
  status: 204
}

export type joinCampaignYoutubeApiV1Response400 = {
  data: void
  status: 400
}
    
export type joinCampaignYoutubeApiV1ResponseComposite = joinCampaignYoutubeApiV1Response204 | joinCampaignYoutubeApiV1Response400;
    
export type joinCampaignYoutubeApiV1Response = joinCampaignYoutubeApiV1ResponseComposite & {
  headers: Headers;
}

export const getJoinCampaignYoutubeApiV1Url = (workspaceId: string,
    campaignId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/campaigns/${campaignId}/join/youtube`
}

export const joinCampaignYoutubeApiV1 = async (workspaceId: string,
    campaignId: string,
    joinCampaignYoutubeRequestDTO: JoinCampaignYoutubeRequestDTO, options?: RequestInit): Promise<joinCampaignYoutubeApiV1Response> => {
  
  return apiClient<joinCampaignYoutubeApiV1Response>(getJoinCampaignYoutubeApiV1Url(workspaceId,campaignId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      joinCampaignYoutubeRequestDTO,)
  }
);}




export const getJoinCampaignYoutubeApiV1MutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinCampaignYoutubeApiV1>>, TError,{workspaceId: string;campaignId: string;data: JoinCampaignYoutubeRequestDTO}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof joinCampaignYoutubeApiV1>>, TError,{workspaceId: string;campaignId: string;data: JoinCampaignYoutubeRequestDTO}, TContext> => {
    
const mutationKey = ['joinCampaignYoutubeApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof joinCampaignYoutubeApiV1>>, {workspaceId: string;campaignId: string;data: JoinCampaignYoutubeRequestDTO}> = (props) => {
          const {workspaceId,campaignId,data} = props ?? {};

          return  joinCampaignYoutubeApiV1(workspaceId,campaignId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type JoinCampaignYoutubeApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof joinCampaignYoutubeApiV1>>>
    export type JoinCampaignYoutubeApiV1MutationBody = JoinCampaignYoutubeRequestDTO
    export type JoinCampaignYoutubeApiV1MutationError = void

    export const useJoinCampaignYoutubeApiV1 = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinCampaignYoutubeApiV1>>, TError,{workspaceId: string;campaignId: string;data: JoinCampaignYoutubeRequestDTO}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof joinCampaignYoutubeApiV1>>,
        TError,
        {workspaceId: string;campaignId: string;data: JoinCampaignYoutubeRequestDTO},
        TContext
      > => {

      const mutationOptions = getJoinCampaignYoutubeApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export type joinCampaignApiV1Response201 = {
  data: void
  status: 201
}
    
export type joinCampaignApiV1ResponseComposite = joinCampaignApiV1Response201;
    
export type joinCampaignApiV1Response = joinCampaignApiV1ResponseComposite & {
  headers: Headers;
}

export const getJoinCampaignApiV1Url = (workspaceId: string,
    campaignId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/campaigns/${campaignId}/join`
}

export const joinCampaignApiV1 = async (workspaceId: string,
    campaignId: string,
    joinCampaignRequestDTO: JoinCampaignRequestDTO, options?: RequestInit): Promise<joinCampaignApiV1Response> => {
  
  return apiClient<joinCampaignApiV1Response>(getJoinCampaignApiV1Url(workspaceId,campaignId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      joinCampaignRequestDTO,)
  }
);}




export const getJoinCampaignApiV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinCampaignApiV1>>, TError,{workspaceId: string;campaignId: string;data: JoinCampaignRequestDTO}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof joinCampaignApiV1>>, TError,{workspaceId: string;campaignId: string;data: JoinCampaignRequestDTO}, TContext> => {
    
const mutationKey = ['joinCampaignApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof joinCampaignApiV1>>, {workspaceId: string;campaignId: string;data: JoinCampaignRequestDTO}> = (props) => {
          const {workspaceId,campaignId,data} = props ?? {};

          return  joinCampaignApiV1(workspaceId,campaignId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type JoinCampaignApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof joinCampaignApiV1>>>
    export type JoinCampaignApiV1MutationBody = JoinCampaignRequestDTO
    export type JoinCampaignApiV1MutationError = unknown

    export const useJoinCampaignApiV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinCampaignApiV1>>, TError,{workspaceId: string;campaignId: string;data: JoinCampaignRequestDTO}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof joinCampaignApiV1>>,
        TError,
        {workspaceId: string;campaignId: string;data: JoinCampaignRequestDTO},
        TContext
      > => {

      const mutationOptions = getJoinCampaignApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export type joinCampaignWaitlistApiV1Response204 = {
  data: void
  status: 204
}

export type joinCampaignWaitlistApiV1Response409 = {
  data: void
  status: 409
}
    
export type joinCampaignWaitlistApiV1ResponseComposite = joinCampaignWaitlistApiV1Response204 | joinCampaignWaitlistApiV1Response409;
    
export type joinCampaignWaitlistApiV1Response = joinCampaignWaitlistApiV1ResponseComposite & {
  headers: Headers;
}

export const getJoinCampaignWaitlistApiV1Url = (workspaceId: string,
    campaignId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/campaigns/${campaignId}/waitlist`
}

export const joinCampaignWaitlistApiV1 = async (workspaceId: string,
    campaignId: string, options?: RequestInit): Promise<joinCampaignWaitlistApiV1Response> => {
  
  return apiClient<joinCampaignWaitlistApiV1Response>(getJoinCampaignWaitlistApiV1Url(workspaceId,campaignId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getJoinCampaignWaitlistApiV1MutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinCampaignWaitlistApiV1>>, TError,{workspaceId: string;campaignId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof joinCampaignWaitlistApiV1>>, TError,{workspaceId: string;campaignId: string}, TContext> => {
    
const mutationKey = ['joinCampaignWaitlistApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof joinCampaignWaitlistApiV1>>, {workspaceId: string;campaignId: string}> = (props) => {
          const {workspaceId,campaignId} = props ?? {};

          return  joinCampaignWaitlistApiV1(workspaceId,campaignId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type JoinCampaignWaitlistApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof joinCampaignWaitlistApiV1>>>
    
    export type JoinCampaignWaitlistApiV1MutationError = void

    export const useJoinCampaignWaitlistApiV1 = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinCampaignWaitlistApiV1>>, TError,{workspaceId: string;campaignId: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof joinCampaignWaitlistApiV1>>,
        TError,
        {workspaceId: string;campaignId: string},
        TContext
      > => {

      const mutationOptions = getJoinCampaignWaitlistApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export type submitCampaignYoutubeVideoApiV1Response204 = {
  data: void
  status: 204
}

export type submitCampaignYoutubeVideoApiV1Response400 = {
  data: void
  status: 400
}
    
export type submitCampaignYoutubeVideoApiV1ResponseComposite = submitCampaignYoutubeVideoApiV1Response204 | submitCampaignYoutubeVideoApiV1Response400;
    
export type submitCampaignYoutubeVideoApiV1Response = submitCampaignYoutubeVideoApiV1ResponseComposite & {
  headers: Headers;
}

export const getSubmitCampaignYoutubeVideoApiV1Url = (workspaceId: string,
    campaignId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/campaigns/${campaignId}/videos/youtube`
}

export const submitCampaignYoutubeVideoApiV1 = async (workspaceId: string,
    campaignId: string,
    submitYoutubeVideoRequestDTO: SubmitYoutubeVideoRequestDTO, options?: RequestInit): Promise<submitCampaignYoutubeVideoApiV1Response> => {
  
  return apiClient<submitCampaignYoutubeVideoApiV1Response>(getSubmitCampaignYoutubeVideoApiV1Url(workspaceId,campaignId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      submitYoutubeVideoRequestDTO,)
  }
);}




export const getSubmitCampaignYoutubeVideoApiV1MutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitCampaignYoutubeVideoApiV1>>, TError,{workspaceId: string;campaignId: string;data: SubmitYoutubeVideoRequestDTO}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof submitCampaignYoutubeVideoApiV1>>, TError,{workspaceId: string;campaignId: string;data: SubmitYoutubeVideoRequestDTO}, TContext> => {
    
const mutationKey = ['submitCampaignYoutubeVideoApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitCampaignYoutubeVideoApiV1>>, {workspaceId: string;campaignId: string;data: SubmitYoutubeVideoRequestDTO}> = (props) => {
          const {workspaceId,campaignId,data} = props ?? {};

          return  submitCampaignYoutubeVideoApiV1(workspaceId,campaignId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitCampaignYoutubeVideoApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof submitCampaignYoutubeVideoApiV1>>>
    export type SubmitCampaignYoutubeVideoApiV1MutationBody = SubmitYoutubeVideoRequestDTO
    export type SubmitCampaignYoutubeVideoApiV1MutationError = void

    export const useSubmitCampaignYoutubeVideoApiV1 = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitCampaignYoutubeVideoApiV1>>, TError,{workspaceId: string;campaignId: string;data: SubmitYoutubeVideoRequestDTO}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof submitCampaignYoutubeVideoApiV1>>,
        TError,
        {workspaceId: string;campaignId: string;data: SubmitYoutubeVideoRequestDTO},
        TContext
      > => {

      const mutationOptions = getSubmitCampaignYoutubeVideoApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export type submitCampaignVideoApiV1Response204 = {
  data: void
  status: 204
}

export type submitCampaignVideoApiV1Response404 = {
  data: void
  status: 404
}
    
export type submitCampaignVideoApiV1ResponseComposite = submitCampaignVideoApiV1Response204 | submitCampaignVideoApiV1Response404;
    
export type submitCampaignVideoApiV1Response = submitCampaignVideoApiV1ResponseComposite & {
  headers: Headers;
}

export const getSubmitCampaignVideoApiV1Url = (workspaceId: string,
    campaignId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/campaigns/${campaignId}/videos`
}

export const submitCampaignVideoApiV1 = async (workspaceId: string,
    campaignId: string,
    submitVideoRequestDTO: SubmitVideoRequestDTO, options?: RequestInit): Promise<submitCampaignVideoApiV1Response> => {
  
  return apiClient<submitCampaignVideoApiV1Response>(getSubmitCampaignVideoApiV1Url(workspaceId,campaignId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      submitVideoRequestDTO,)
  }
);}




export const getSubmitCampaignVideoApiV1MutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitCampaignVideoApiV1>>, TError,{workspaceId: string;campaignId: string;data: SubmitVideoRequestDTO}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof submitCampaignVideoApiV1>>, TError,{workspaceId: string;campaignId: string;data: SubmitVideoRequestDTO}, TContext> => {
    
const mutationKey = ['submitCampaignVideoApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitCampaignVideoApiV1>>, {workspaceId: string;campaignId: string;data: SubmitVideoRequestDTO}> = (props) => {
          const {workspaceId,campaignId,data} = props ?? {};

          return  submitCampaignVideoApiV1(workspaceId,campaignId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitCampaignVideoApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof submitCampaignVideoApiV1>>>
    export type SubmitCampaignVideoApiV1MutationBody = SubmitVideoRequestDTO
    export type SubmitCampaignVideoApiV1MutationError = void

    export const useSubmitCampaignVideoApiV1 = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitCampaignVideoApiV1>>, TError,{workspaceId: string;campaignId: string;data: SubmitVideoRequestDTO}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof submitCampaignVideoApiV1>>,
        TError,
        {workspaceId: string;campaignId: string;data: SubmitVideoRequestDTO},
        TContext
      > => {

      const mutationOptions = getSubmitCampaignVideoApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export type getCampaignVideoPreviewApiV1Response200 = {
  data: GetVideoPreviewResponseDTO
  status: 200
}

export type getCampaignVideoPreviewApiV1Response400 = {
  data: void
  status: 400
}
    
export type getCampaignVideoPreviewApiV1ResponseComposite = getCampaignVideoPreviewApiV1Response200 | getCampaignVideoPreviewApiV1Response400;
    
export type getCampaignVideoPreviewApiV1Response = getCampaignVideoPreviewApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetCampaignVideoPreviewApiV1Url = (workspaceId: string,
    campaignId: string,
    params: GetCampaignVideoPreviewApiV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `http://localhost:8888/api/v1/workspaces/${workspaceId}/campaigns/${campaignId}/videos/preview?${stringifiedParams}` : `http://localhost:8888/api/v1/workspaces/${workspaceId}/campaigns/${campaignId}/videos/preview`
}

export const getCampaignVideoPreviewApiV1 = async (workspaceId: string,
    campaignId: string,
    params: GetCampaignVideoPreviewApiV1Params, options?: RequestInit): Promise<getCampaignVideoPreviewApiV1Response> => {
  
  return apiClient<getCampaignVideoPreviewApiV1Response>(getGetCampaignVideoPreviewApiV1Url(workspaceId,campaignId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetCampaignVideoPreviewApiV1QueryKey = (workspaceId: string,
    campaignId: string,
    params: GetCampaignVideoPreviewApiV1Params,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/campaigns/${campaignId}/videos/preview`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCampaignVideoPreviewApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>, TError = void>(workspaceId: string,
    campaignId: string,
    params: GetCampaignVideoPreviewApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampaignVideoPreviewApiV1QueryKey(workspaceId,campaignId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>> = ({ signal }) => getCampaignVideoPreviewApiV1(workspaceId,campaignId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && campaignId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignVideoPreviewApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>>
export type GetCampaignVideoPreviewApiV1QueryError = void


export function useGetCampaignVideoPreviewApiV1<TData = Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>, TError = void>(
 workspaceId: string,
    campaignId: string,
    params: GetCampaignVideoPreviewApiV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>,
          TError,
          Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignVideoPreviewApiV1<TData = Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>, TError = void>(
 workspaceId: string,
    campaignId: string,
    params: GetCampaignVideoPreviewApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>,
          TError,
          Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignVideoPreviewApiV1<TData = Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>, TError = void>(
 workspaceId: string,
    campaignId: string,
    params: GetCampaignVideoPreviewApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCampaignVideoPreviewApiV1<TData = Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>, TError = void>(
 workspaceId: string,
    campaignId: string,
    params: GetCampaignVideoPreviewApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCampaignVideoPreviewApiV1QueryOptions(workspaceId,campaignId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCampaignVideoPreviewApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>, TError = void>(workspaceId: string,
    campaignId: string,
    params: GetCampaignVideoPreviewApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampaignVideoPreviewApiV1QueryKey(workspaceId,campaignId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>> = ({ signal }) => getCampaignVideoPreviewApiV1(workspaceId,campaignId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignVideoPreviewApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>>
export type GetCampaignVideoPreviewApiV1SuspenseQueryError = void


export function useGetCampaignVideoPreviewApiV1Suspense<TData = Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>, TError = void>(
 workspaceId: string,
    campaignId: string,
    params: GetCampaignVideoPreviewApiV1Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignVideoPreviewApiV1Suspense<TData = Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>, TError = void>(
 workspaceId: string,
    campaignId: string,
    params: GetCampaignVideoPreviewApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignVideoPreviewApiV1Suspense<TData = Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>, TError = void>(
 workspaceId: string,
    campaignId: string,
    params: GetCampaignVideoPreviewApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCampaignVideoPreviewApiV1Suspense<TData = Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>, TError = void>(
 workspaceId: string,
    campaignId: string,
    params: GetCampaignVideoPreviewApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCampaignVideoPreviewApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCampaignVideoPreviewApiV1SuspenseQueryOptions(workspaceId,campaignId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type getPayoutStatusApiV1Response200 = {
  data: GetPayoutStatusResponseDto
  status: 200
}
    
export type getPayoutStatusApiV1ResponseComposite = getPayoutStatusApiV1Response200;
    
export type getPayoutStatusApiV1Response = getPayoutStatusApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetPayoutStatusApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/payout/status`
}

export const getPayoutStatusApiV1 = async (workspaceId: string, options?: RequestInit): Promise<getPayoutStatusApiV1Response> => {
  
  return apiClient<getPayoutStatusApiV1Response>(getGetPayoutStatusApiV1Url(workspaceId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetPayoutStatusApiV1QueryKey = (workspaceId: string,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/payout/status`] as const;
    }

    
export const getGetPayoutStatusApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getPayoutStatusApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutStatusApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayoutStatusApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayoutStatusApiV1>>> = ({ signal }) => getPayoutStatusApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayoutStatusApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayoutStatusApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getPayoutStatusApiV1>>>
export type GetPayoutStatusApiV1QueryError = unknown


export function useGetPayoutStatusApiV1<TData = Awaited<ReturnType<typeof getPayoutStatusApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutStatusApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayoutStatusApiV1>>,
          TError,
          Awaited<ReturnType<typeof getPayoutStatusApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayoutStatusApiV1<TData = Awaited<ReturnType<typeof getPayoutStatusApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutStatusApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayoutStatusApiV1>>,
          TError,
          Awaited<ReturnType<typeof getPayoutStatusApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayoutStatusApiV1<TData = Awaited<ReturnType<typeof getPayoutStatusApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutStatusApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPayoutStatusApiV1<TData = Awaited<ReturnType<typeof getPayoutStatusApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutStatusApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayoutStatusApiV1QueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetPayoutStatusApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPayoutStatusApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPayoutStatusApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayoutStatusApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayoutStatusApiV1>>> = ({ signal }) => getPayoutStatusApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPayoutStatusApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayoutStatusApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPayoutStatusApiV1>>>
export type GetPayoutStatusApiV1SuspenseQueryError = unknown


export function useGetPayoutStatusApiV1Suspense<TData = Awaited<ReturnType<typeof getPayoutStatusApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPayoutStatusApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayoutStatusApiV1Suspense<TData = Awaited<ReturnType<typeof getPayoutStatusApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPayoutStatusApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayoutStatusApiV1Suspense<TData = Awaited<ReturnType<typeof getPayoutStatusApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPayoutStatusApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPayoutStatusApiV1Suspense<TData = Awaited<ReturnType<typeof getPayoutStatusApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPayoutStatusApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayoutStatusApiV1SuspenseQueryOptions(workspaceId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type getPayoutMethodsApiV1Response200 = {
  data: GetPayoutMethodsResponseDto
  status: 200
}
    
export type getPayoutMethodsApiV1ResponseComposite = getPayoutMethodsApiV1Response200;
    
export type getPayoutMethodsApiV1Response = getPayoutMethodsApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetPayoutMethodsApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/payout/methods`
}

export const getPayoutMethodsApiV1 = async (workspaceId: string, options?: RequestInit): Promise<getPayoutMethodsApiV1Response> => {
  
  return apiClient<getPayoutMethodsApiV1Response>(getGetPayoutMethodsApiV1Url(workspaceId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetPayoutMethodsApiV1QueryKey = (workspaceId: string,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/payout/methods`] as const;
    }

    
export const getGetPayoutMethodsApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getPayoutMethodsApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutMethodsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayoutMethodsApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayoutMethodsApiV1>>> = ({ signal }) => getPayoutMethodsApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayoutMethodsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayoutMethodsApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getPayoutMethodsApiV1>>>
export type GetPayoutMethodsApiV1QueryError = unknown


export function useGetPayoutMethodsApiV1<TData = Awaited<ReturnType<typeof getPayoutMethodsApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutMethodsApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayoutMethodsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getPayoutMethodsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayoutMethodsApiV1<TData = Awaited<ReturnType<typeof getPayoutMethodsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutMethodsApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayoutMethodsApiV1>>,
          TError,
          Awaited<ReturnType<typeof getPayoutMethodsApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayoutMethodsApiV1<TData = Awaited<ReturnType<typeof getPayoutMethodsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutMethodsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPayoutMethodsApiV1<TData = Awaited<ReturnType<typeof getPayoutMethodsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutMethodsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayoutMethodsApiV1QueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetPayoutMethodsApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPayoutMethodsApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPayoutMethodsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayoutMethodsApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayoutMethodsApiV1>>> = ({ signal }) => getPayoutMethodsApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPayoutMethodsApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayoutMethodsApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPayoutMethodsApiV1>>>
export type GetPayoutMethodsApiV1SuspenseQueryError = unknown


export function useGetPayoutMethodsApiV1Suspense<TData = Awaited<ReturnType<typeof getPayoutMethodsApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPayoutMethodsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayoutMethodsApiV1Suspense<TData = Awaited<ReturnType<typeof getPayoutMethodsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPayoutMethodsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayoutMethodsApiV1Suspense<TData = Awaited<ReturnType<typeof getPayoutMethodsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPayoutMethodsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPayoutMethodsApiV1Suspense<TData = Awaited<ReturnType<typeof getPayoutMethodsApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPayoutMethodsApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayoutMethodsApiV1SuspenseQueryOptions(workspaceId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type updatePayoutTaxInformationApiV1Response204 = {
  data: void
  status: 204
}
    
export type updatePayoutTaxInformationApiV1ResponseComposite = updatePayoutTaxInformationApiV1Response204;
    
export type updatePayoutTaxInformationApiV1Response = updatePayoutTaxInformationApiV1ResponseComposite & {
  headers: Headers;
}

export const getUpdatePayoutTaxInformationApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/payout/tax-information`
}

export const updatePayoutTaxInformationApiV1 = async (workspaceId: string,
    updateTaxInformationRequestDto: UpdateTaxInformationRequestDto, options?: RequestInit): Promise<updatePayoutTaxInformationApiV1Response> => {
  
  return apiClient<updatePayoutTaxInformationApiV1Response>(getUpdatePayoutTaxInformationApiV1Url(workspaceId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateTaxInformationRequestDto,)
  }
);}




export const getUpdatePayoutTaxInformationApiV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePayoutTaxInformationApiV1>>, TError,{workspaceId: string;data: UpdateTaxInformationRequestDto}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePayoutTaxInformationApiV1>>, TError,{workspaceId: string;data: UpdateTaxInformationRequestDto}, TContext> => {
    
const mutationKey = ['updatePayoutTaxInformationApiV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePayoutTaxInformationApiV1>>, {workspaceId: string;data: UpdateTaxInformationRequestDto}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  updatePayoutTaxInformationApiV1(workspaceId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePayoutTaxInformationApiV1MutationResult = NonNullable<Awaited<ReturnType<typeof updatePayoutTaxInformationApiV1>>>
    export type UpdatePayoutTaxInformationApiV1MutationBody = UpdateTaxInformationRequestDto
    export type UpdatePayoutTaxInformationApiV1MutationError = unknown

    export const useUpdatePayoutTaxInformationApiV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePayoutTaxInformationApiV1>>, TError,{workspaceId: string;data: UpdateTaxInformationRequestDto}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof updatePayoutTaxInformationApiV1>>,
        TError,
        {workspaceId: string;data: UpdateTaxInformationRequestDto},
        TContext
      > => {

      const mutationOptions = getUpdatePayoutTaxInformationApiV1MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export type getTrolleyLinkApiV1Response200 = {
  data: GetTrolleyLinkResponseDto
  status: 200
}
    
export type getTrolleyLinkApiV1ResponseComposite = getTrolleyLinkApiV1Response200;
    
export type getTrolleyLinkApiV1Response = getTrolleyLinkApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetTrolleyLinkApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/payout/tax/link`
}

export const getTrolleyLinkApiV1 = async (workspaceId: string, options?: RequestInit): Promise<getTrolleyLinkApiV1Response> => {
  
  return apiClient<getTrolleyLinkApiV1Response>(getGetTrolleyLinkApiV1Url(workspaceId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetTrolleyLinkApiV1QueryKey = (workspaceId: string,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/payout/tax/link`] as const;
    }

    
export const getGetTrolleyLinkApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getTrolleyLinkApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrolleyLinkApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrolleyLinkApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrolleyLinkApiV1>>> = ({ signal }) => getTrolleyLinkApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrolleyLinkApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTrolleyLinkApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getTrolleyLinkApiV1>>>
export type GetTrolleyLinkApiV1QueryError = unknown


export function useGetTrolleyLinkApiV1<TData = Awaited<ReturnType<typeof getTrolleyLinkApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrolleyLinkApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrolleyLinkApiV1>>,
          TError,
          Awaited<ReturnType<typeof getTrolleyLinkApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrolleyLinkApiV1<TData = Awaited<ReturnType<typeof getTrolleyLinkApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrolleyLinkApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrolleyLinkApiV1>>,
          TError,
          Awaited<ReturnType<typeof getTrolleyLinkApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrolleyLinkApiV1<TData = Awaited<ReturnType<typeof getTrolleyLinkApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrolleyLinkApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTrolleyLinkApiV1<TData = Awaited<ReturnType<typeof getTrolleyLinkApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrolleyLinkApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrolleyLinkApiV1QueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetTrolleyLinkApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTrolleyLinkApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrolleyLinkApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrolleyLinkApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrolleyLinkApiV1>>> = ({ signal }) => getTrolleyLinkApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrolleyLinkApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTrolleyLinkApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTrolleyLinkApiV1>>>
export type GetTrolleyLinkApiV1SuspenseQueryError = unknown


export function useGetTrolleyLinkApiV1Suspense<TData = Awaited<ReturnType<typeof getTrolleyLinkApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrolleyLinkApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrolleyLinkApiV1Suspense<TData = Awaited<ReturnType<typeof getTrolleyLinkApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrolleyLinkApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrolleyLinkApiV1Suspense<TData = Awaited<ReturnType<typeof getTrolleyLinkApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrolleyLinkApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTrolleyLinkApiV1Suspense<TData = Awaited<ReturnType<typeof getTrolleyLinkApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTrolleyLinkApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrolleyLinkApiV1SuspenseQueryOptions(workspaceId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type getTaxInformationApiV1Response200 = {
  data: GetTaxInfoResponseDto
  status: 200
}
    
export type getTaxInformationApiV1ResponseComposite = getTaxInformationApiV1Response200;
    
export type getTaxInformationApiV1Response = getTaxInformationApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetTaxInformationApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/payout/tax`
}

export const getTaxInformationApiV1 = async (workspaceId: string, options?: RequestInit): Promise<getTaxInformationApiV1Response> => {
  
  return apiClient<getTaxInformationApiV1Response>(getGetTaxInformationApiV1Url(workspaceId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetTaxInformationApiV1QueryKey = (workspaceId: string,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/payout/tax`] as const;
    }

    
export const getGetTaxInformationApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getTaxInformationApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaxInformationApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaxInformationApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaxInformationApiV1>>> = ({ signal }) => getTaxInformationApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaxInformationApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTaxInformationApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getTaxInformationApiV1>>>
export type GetTaxInformationApiV1QueryError = unknown


export function useGetTaxInformationApiV1<TData = Awaited<ReturnType<typeof getTaxInformationApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaxInformationApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaxInformationApiV1>>,
          TError,
          Awaited<ReturnType<typeof getTaxInformationApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaxInformationApiV1<TData = Awaited<ReturnType<typeof getTaxInformationApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaxInformationApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaxInformationApiV1>>,
          TError,
          Awaited<ReturnType<typeof getTaxInformationApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaxInformationApiV1<TData = Awaited<ReturnType<typeof getTaxInformationApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaxInformationApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTaxInformationApiV1<TData = Awaited<ReturnType<typeof getTaxInformationApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaxInformationApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTaxInformationApiV1QueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetTaxInformationApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTaxInformationApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTaxInformationApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaxInformationApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaxInformationApiV1>>> = ({ signal }) => getTaxInformationApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTaxInformationApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTaxInformationApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTaxInformationApiV1>>>
export type GetTaxInformationApiV1SuspenseQueryError = unknown


export function useGetTaxInformationApiV1Suspense<TData = Awaited<ReturnType<typeof getTaxInformationApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTaxInformationApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaxInformationApiV1Suspense<TData = Awaited<ReturnType<typeof getTaxInformationApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTaxInformationApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaxInformationApiV1Suspense<TData = Awaited<ReturnType<typeof getTaxInformationApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTaxInformationApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTaxInformationApiV1Suspense<TData = Awaited<ReturnType<typeof getTaxInformationApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTaxInformationApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTaxInformationApiV1SuspenseQueryOptions(workspaceId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type getChannelSettlementHistoryApiV1Response200 = {
  data: GetPayoutHistoryByChannelResponseDto
  status: 200
}
    
export type getChannelSettlementHistoryApiV1ResponseComposite = getChannelSettlementHistoryApiV1Response200;
    
export type getChannelSettlementHistoryApiV1Response = getChannelSettlementHistoryApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetChannelSettlementHistoryApiV1Url = (workspaceId: string,
    params: GetChannelSettlementHistoryApiV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `http://localhost:8888/api/v1/workspaces/${workspaceId}/payout/channels?${stringifiedParams}` : `http://localhost:8888/api/v1/workspaces/${workspaceId}/payout/channels`
}

export const getChannelSettlementHistoryApiV1 = async (workspaceId: string,
    params: GetChannelSettlementHistoryApiV1Params, options?: RequestInit): Promise<getChannelSettlementHistoryApiV1Response> => {
  
  return apiClient<getChannelSettlementHistoryApiV1Response>(getGetChannelSettlementHistoryApiV1Url(workspaceId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetChannelSettlementHistoryApiV1QueryKey = (workspaceId: string,
    params: GetChannelSettlementHistoryApiV1Params,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/payout/channels`, ...(params ? [params]: [])] as const;
    }

    
export const getGetChannelSettlementHistoryApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>, TError = unknown>(workspaceId: string,
    params: GetChannelSettlementHistoryApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChannelSettlementHistoryApiV1QueryKey(workspaceId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>> = ({ signal }) => getChannelSettlementHistoryApiV1(workspaceId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetChannelSettlementHistoryApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>>
export type GetChannelSettlementHistoryApiV1QueryError = unknown


export function useGetChannelSettlementHistoryApiV1<TData = Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>, TError = unknown>(
 workspaceId: string,
    params: GetChannelSettlementHistoryApiV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>,
          TError,
          Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChannelSettlementHistoryApiV1<TData = Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>, TError = unknown>(
 workspaceId: string,
    params: GetChannelSettlementHistoryApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>,
          TError,
          Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChannelSettlementHistoryApiV1<TData = Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>, TError = unknown>(
 workspaceId: string,
    params: GetChannelSettlementHistoryApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetChannelSettlementHistoryApiV1<TData = Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>, TError = unknown>(
 workspaceId: string,
    params: GetChannelSettlementHistoryApiV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChannelSettlementHistoryApiV1QueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetChannelSettlementHistoryApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>, TError = unknown>(workspaceId: string,
    params: GetChannelSettlementHistoryApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChannelSettlementHistoryApiV1QueryKey(workspaceId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>> = ({ signal }) => getChannelSettlementHistoryApiV1(workspaceId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetChannelSettlementHistoryApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>>
export type GetChannelSettlementHistoryApiV1SuspenseQueryError = unknown


export function useGetChannelSettlementHistoryApiV1Suspense<TData = Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>, TError = unknown>(
 workspaceId: string,
    params: GetChannelSettlementHistoryApiV1Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChannelSettlementHistoryApiV1Suspense<TData = Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>, TError = unknown>(
 workspaceId: string,
    params: GetChannelSettlementHistoryApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChannelSettlementHistoryApiV1Suspense<TData = Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>, TError = unknown>(
 workspaceId: string,
    params: GetChannelSettlementHistoryApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetChannelSettlementHistoryApiV1Suspense<TData = Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>, TError = unknown>(
 workspaceId: string,
    params: GetChannelSettlementHistoryApiV1Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChannelSettlementHistoryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChannelSettlementHistoryApiV1SuspenseQueryOptions(workspaceId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type getSettlementHistoryApiV1Response200 = {
  data: GetSettlementHistoryResponseDto
  status: 200
}
    
export type getSettlementHistoryApiV1ResponseComposite = getSettlementHistoryApiV1Response200;
    
export type getSettlementHistoryApiV1Response = getSettlementHistoryApiV1ResponseComposite & {
  headers: Headers;
}

export const getGetSettlementHistoryApiV1Url = (workspaceId: string,) => {


  

  return `http://localhost:8888/api/v1/workspaces/${workspaceId}/payout/settlements`
}

export const getSettlementHistoryApiV1 = async (workspaceId: string, options?: RequestInit): Promise<getSettlementHistoryApiV1Response> => {
  
  return apiClient<getSettlementHistoryApiV1Response>(getGetSettlementHistoryApiV1Url(workspaceId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getGetSettlementHistoryApiV1QueryKey = (workspaceId: string,) => {
    return [`http://localhost:8888/api/v1/workspaces/${workspaceId}/payout/settlements`] as const;
    }

    
export const getGetSettlementHistoryApiV1QueryOptions = <TData = Awaited<ReturnType<typeof getSettlementHistoryApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettlementHistoryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSettlementHistoryApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettlementHistoryApiV1>>> = ({ signal }) => getSettlementHistoryApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSettlementHistoryApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettlementHistoryApiV1QueryResult = NonNullable<Awaited<ReturnType<typeof getSettlementHistoryApiV1>>>
export type GetSettlementHistoryApiV1QueryError = unknown


export function useGetSettlementHistoryApiV1<TData = Awaited<ReturnType<typeof getSettlementHistoryApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettlementHistoryApiV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettlementHistoryApiV1>>,
          TError,
          Awaited<ReturnType<typeof getSettlementHistoryApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettlementHistoryApiV1<TData = Awaited<ReturnType<typeof getSettlementHistoryApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettlementHistoryApiV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettlementHistoryApiV1>>,
          TError,
          Awaited<ReturnType<typeof getSettlementHistoryApiV1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettlementHistoryApiV1<TData = Awaited<ReturnType<typeof getSettlementHistoryApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettlementHistoryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSettlementHistoryApiV1<TData = Awaited<ReturnType<typeof getSettlementHistoryApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettlementHistoryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSettlementHistoryApiV1QueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetSettlementHistoryApiV1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSettlementHistoryApiV1>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSettlementHistoryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSettlementHistoryApiV1QueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettlementHistoryApiV1>>> = ({ signal }) => getSettlementHistoryApiV1(workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSettlementHistoryApiV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettlementHistoryApiV1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSettlementHistoryApiV1>>>
export type GetSettlementHistoryApiV1SuspenseQueryError = unknown


export function useGetSettlementHistoryApiV1Suspense<TData = Awaited<ReturnType<typeof getSettlementHistoryApiV1>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSettlementHistoryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettlementHistoryApiV1Suspense<TData = Awaited<ReturnType<typeof getSettlementHistoryApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSettlementHistoryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettlementHistoryApiV1Suspense<TData = Awaited<ReturnType<typeof getSettlementHistoryApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSettlementHistoryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSettlementHistoryApiV1Suspense<TData = Awaited<ReturnType<typeof getSettlementHistoryApiV1>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSettlementHistoryApiV1>>, TError, TData>>, request?: SecondParameter<typeof apiClient>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSettlementHistoryApiV1SuspenseQueryOptions(workspaceId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}
